webpackJsonp([107,105],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _toConsumableArray2 = __webpack_require__(159);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(21);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _index = __webpack_require__(3172);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _lib = __webpack_require__(3170);
	
	var _lib2 = _interopRequireDefault(_lib);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(4277);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueI18n = __webpack_require__(3568);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _vueResource = __webpack_require__(4276);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _detectBrowser = __webpack_require__(3161);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	var _vuelidate = __webpack_require__(4279);
	
	var _vuelidate2 = _interopRequireDefault(_vuelidate);
	
	var _index3 = __webpack_require__(1356);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _definition = __webpack_require__(13);
	
	var _definition2 = __webpack_require__(12);
	
	var _routes = __webpack_require__(2374);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _vueLayer = __webpack_require__(3570);
	
	var _vueLayer2 = _interopRequireDefault(_vueLayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.prototype.$layer = (0, _vueLayer2.default)(_vue2.default);
	
	var LoginView = function LoginView(resolve) {
	  return __webpack_require__.e/* require */(96, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3578)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var LoginView2 = function LoginView2(resolve) {
	  return __webpack_require__.e/* require */(103, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3579)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var HomeView = function HomeView(resolve) {
	  return __webpack_require__.e/* require */(86, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3575)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var LabView = function LabView(resolve) {
	  return __webpack_require__.e/* require */(85, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3669)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Datatable2 = function Datatable2(resolve) {
	  return __webpack_require__.e/* require */(39, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3672)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var Timeout = function Timeout(resolve) {
	  return __webpack_require__.e/* require */(99, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3674)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var locales = {
	  en: __webpack_require__(2210).default
	};
	var BrowserNotSupport = function BrowserNotSupport(resolve) {
	  return __webpack_require__.e/* require */(104, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3673)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_lib2.default);
	_vue2.default.use(_vuelidate2.default);
	
	_vue2.default.config.lang = 'en';
	
	(0, _keys2.default)(locales).forEach(function (lang) {
	  _vue2.default.locale(lang, locales[lang]);
	});
	
	var router = new _vueRouter2.default({
	  routes: [{ path: '/login', component: LoginView }, { path: '/lab', component: LabView }, { path: '/datatable2', component: Datatable2 }, { path: '/login2', component: LoginView2 }, { path: '/browser-not-support', component: BrowserNotSupport }, { path: '/timeout', component: Timeout }, {
	    path: '/',
	    component: HomeView,
	
	    children: [].concat((0, _toConsumableArray3.default)(_routes2.default))
	  }]
	});
	
	router.beforeEach(function (to, from, next) {
	  if (_detectBrowser2.default.name !== 'chrome' && to.path !== '/browser-not-support') {
	    next({ path: '/browser-not-support' });
	    return;
	  }
	
	  var publicPaths = ['/browser-not-support', '/login', '/timeout'];
	  if (publicPaths.includes(to.path)) {
	    next();
	    return;
	  }
	
	  if (_index4.default.getters[_definition.USER] !== null) {
	    next();
	    return;
	  }
	
	  _vue2.default.http.get('/smee/user-details').then(function (response) {
	    if (response.ok && response.body && response.body.user) {
	      _index4.default.dispatch(_definition.INIT_STATE, {
	        user: response.body.user,
	        store: _index4.default
	      }).then(function () {
	        return _index4.default.dispatch(_definition2.initialize);
	      }).then(function () {
	        next({ path: '/landing-page' });
	      }).catch(function () {
	        next({ path: '/landing-page' });
	      });
	    } else if (response.status === 403) {
	      window.location.href = '/smee/access-denied';
	    } else {
	      window.location.href = '/smee/oauth2/authorization/pingidentity';
	    }
	  }).catch(function () {
	    window.location.href = '/smee/oauth2/authorization/pingidentity';
	  });
	});
	
	new _vue2.default({
	  router: router,
	  store: _index4.default
	}).$mount('#app');
	
	_vue2.default.http.interceptors.push(function (request, next) {
	  if (request.url.indexOf('/sms') >= 0 || request.url.indexOf('/fabrictracker') >= 0) {
	    request.headers.set('SMEEToken', request.headers.get('Authorization').substring(7));
	  }
	  next();
	});

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var smsPrefixed = function smsPrefixed(name) {
	  return 'samplemanagement/common/' + name;
	};
	var prefixed = function prefixed(name) {
	  return 'common/' + name;
	};
	
	var searchCriteria = exports.searchCriteria = smsPrefixed('searchCriteria');
	var commonSearchCriteria = exports.commonSearchCriteria = prefixed('searchCriteria');
	
	var age = exports.age = smsPrefixed('age');
	var brandCodes = exports.brandCodes = smsPrefixed('brandCodes');
	var categoryCodes = exports.categoryCodes = smsPrefixed('categoryCodes');
	var classCodes = exports.classCodes = smsPrefixed('classCodes');
	var cocCatalogs = exports.cocCatalogs = smsPrefixed('cocCatalogs');
	var cocFabric = exports.cocFabric = smsPrefixed('cocFabric');
	var cocSubCategory = exports.cocSubCategory = smsPrefixed('cocSubCategory');
	var coos = exports.coos = smsPrefixed('coos');
	var deactivatedAdSampleTypes = exports.deactivatedAdSampleTypes = smsPrefixed('deactivatedAdSampleTypes');
	var deactivatedPurposes = exports.deactivatedPurposes = smsPrefixed('deactivatedPurposes');
	var departmentCodes = exports.departmentCodes = smsPrefixed('departmentCodes');
	var devSearchParamsCache = exports.devSearchParamsCache = smsPrefixed('devSearchParamsCache');
	var distros = exports.distros = smsPrefixed('distros');
	var divisionCodes = exports.divisionCodes = smsPrefixed('divisionCodes');
	var end = exports.end = smsPrefixed('end');
	var flowLongDescriptions = exports.flowLongDescriptions = smsPrefixed('flowLongDescriptions');
	var flowNames = exports.flowNames = smsPrefixed('flowNames');
	var orderingTimelinesss = exports.orderingTimelinesss = smsPrefixed('orderingTimelinesss');
	var gauge = exports.gauge = smsPrefixed('gauge');
	var gender = exports.gender = smsPrefixed('gender');
	var gisAgentCodes = exports.gisAgentCodes = smsPrefixed('gisAgentCodes');
	var gisAgents = exports.gisAgents = smsPrefixed('gisAgents');
	var inStoreDates = exports.inStoreDates = smsPrefixed('inStoreDates');
	var itemTypes = exports.itemTypes = smsPrefixed('itemTypes');
	var keyCostDriver = exports.keyCostDriver = smsPrefixed('keyCostDriver');
	var linePlans = exports.linePlans = smsPrefixed('linePlans');
	var marketCodes = exports.marketCodes = smsPrefixed('marketCodes');
	var materialAction = exports.materialAction = smsPrefixed('materialAction');
	var planningPeriods = exports.planningPeriods = smsPrefixed('planningPeriods');
	var planningYears = exports.planningYears = smsPrefixed('planningYears');
	var plmSampleTypes = exports.plmSampleTypes = smsPrefixed('plmSampleTypes');
	var productTeam = exports.productTeam = smsPrefixed('productTeam');
	var productTypes = exports.productTypes = smsPrefixed('productTypes');
	var purposes = exports.purposes = smsPrefixed('purposes');
	var rawMaterialType = exports.rawMaterialType = smsPrefixed('rawMaterialType');
	var requestPurpose = exports.requestPurpose = smsPrefixed('requestPurpose');
	var roundNum = exports.roundNum = smsPrefixed('roundNum');
	var sampleMarkets = exports.sampleMarkets = smsPrefixed('sampleMarkets');
	var seasonalWorkspace = exports.seasonalWorkspace = smsPrefixed('seasonalWorkspace');
	var shipToAttns = exports.shipToAttns = smsPrefixed('shipToAttns');
	var sizeModels = exports.sizeModels = smsPrefixed('sizeModels');
	var smrSearchParamsCache = exports.smrSearchParamsCache = smsPrefixed('smrSearchParamsCache');
	var smrStatus = exports.smrStatus = smsPrefixed('smrStatus');
	var ssns = exports.ssns = smsPrefixed('ssns');
	var subCategoryCodes = exports.subCategoryCodes = smsPrefixed('subCategoryCodes');
	var subClassCodes = exports.subClassCodes = smsPrefixed('subClassCodes');
	var svdOffice = exports.svdOffice = smsPrefixed('svdOffice');
	var smrLateReasons = exports.smrLateReasons = smsPrefixed('smrLateReasons');
	var smrOrderingTimeliness = exports.smrOrderingTimeliness = smsPrefixed('smrOrderingTimeliness');
	var smrYardageTimeliness = exports.smrYardageTimeliness = smsPrefixed('smrYardageTimeliness');
	var IS_SMS_VENDOR = exports.IS_SMS_VENDOR = smsPrefixed('IS_SMS_VENDOR');

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefixed = function prefixed(name) {
	  return 'common/' + name;
	};
	
	var brands = exports.brands = prefixed('brands');
	var categories = exports.categories = prefixed('categories');
	var subCategories = exports.subCategories = prefixed('subCategories');
	var years = exports.years = prefixed('years');
	var seasons = exports.seasons = prefixed('seasons');
	var markets = exports.markets = prefixed('markets');
	var channels = exports.channels = prefixed('channels');
	var countries = exports.countries = prefixed('countries');
	var divisions = exports.divisions = prefixed('divisions');
	var departments = exports.departments = prefixed('departments');
	var classes = exports.classes = prefixed('classes');
	var subClasses = exports.subClasses = prefixed('subClasses');
	var vendors = exports.vendors = prefixed('vendors');
	var mills = exports.mills = prefixed('mills');
	var vendorGroups = exports.vendorGroups = prefixed('vendorGroups');
	var searchCriteria = exports.searchCriteria = prefixed('searchCriteria');
	
	var isLoaded = exports.isLoaded = prefixed('isLoaded');
	
	var preInit = exports.preInit = prefixed('preInit');
	var initialize = exports.initialize = prefixed('initialize');

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ACCESS_GROUPS = exports.ACCESS_GROUPS = 'ACCESS_GROUPS';
	var ALERTS = exports.ALERTS = 'ALERTS';
	var USER_FULL_NAME = exports.USER_FULL_NAME = 'USER_FULL_NAME';
	var MENU = exports.MENU = 'MENU';
	var USER = exports.USER = 'USER';
	var PAGE = exports.PAGE = 'PAGE';
	
	var SET_USER = exports.SET_USER = 'SET_USER';
	var ADD_ALERT = exports.ADD_ALERT = 'ADD_ALERT';
	var REMOVE_ALERT = exports.REMOVE_ALERT = 'REMOVE_ALERT';
	
	var INIT_STATE = exports.INIT_STATE = 'INIT_STATE';
	var RELEASE_STATE = exports.RELEASE_STATE = 'RELEASE_STATE';
	var ALERT_SUCCESS = exports.ALERT_SUCCESS = 'ALERT_SUCCESS';
	var ALERT_INFO = exports.ALERT_INFO = 'ALERT_INFO';
	var ALERT_WARNING = exports.ALERT_WARNING = 'ALERT_WARNING';
	var ALERT_DANGER = exports.ALERT_DANGER = 'ALERT_DANGER';
	var ALERT_AUTO_DISMISS = exports.ALERT_AUTO_DISMISS = 'ALERT_AUTO_DISMISS';
	
	var IS_APP_JS_LOADED = exports.IS_APP_JS_LOADED = 'IS_APP_JS_LOADED';
	var IS_ALLOWED = exports.IS_ALLOWED = 'IS_ALLOWED';
	var SET_APP_JS_LOADED = exports.SET_APP_JS_LOADED = 'SET_APP_JS_LOADED';
	var CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES = exports.CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES = 'CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES';
	var IS_APP_LOADING = exports.IS_APP_LOADING = 'IS_APP_LOADING';
	var SET_PAGE = exports.SET_PAGE = 'SET_PAGE';
	var SET_CRAR_DATA = exports.SET_CRAR_DATA = 'SET_CRAR_DATA';
	var CRAR_DATA = exports.CRAR_DATA = 'CRAR_DATA';

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newBookingApplicationUrl = exports.rowsPerPageOptions = exports.redbannerScheduler = exports.smee = exports.microservice = exports.redmine = undefined;
	
	var _decrypt_pwd = __webpack_require__(2165);
	
	var redmine = exports.redmine = {
	  domain: 'https://smeestage.gapinc.com/',
	  adminApiKey: (0, _decrypt_pwd.ENC)('U2FsdGVkX1+HEyD02h8pcKqBHm92dZW/Yd+KfZdBqI+9JmDJEIEPVuaSSpdRpM8LUpOnG76d/FIJkDMyqf1bvg==')
	};
	var microservice = exports.microservice = {
	  domain: '/smee'
	};
	var smee = exports.smee = {
	  complexServiceUrl: 'https://rpt-search-service-production.apps.cfprod.phx.gaptech.com/rpt-search-service/sourcing/responsive-product-groups/search',
	  userName: 'rpt_client',
	  passWord: (0, _decrypt_pwd.ENC)('U2FsdGVkX1+SD0RwpGKaxzVhilHGLgeIiVbDpSHQRPoipNw2QFjYoqePUcI1izQE'),
	  sharepoint: {
	    vpseFolderId: 'SMEEstage/vpse',
	    trmFolderId: 'SMEEstage/trm',
	    qasFolderId: 'SMEEstage/qas',
	    pclFolderId: 'SMEEstage/pcl',
	    wipFolderId: 'SMEEstage/wip',
	    mstVendorConnectFolderId: 'SMEEstage/mst',
	    commitmentFolderId: 'SMEEstage/commitment'
	  }
	};
	
	var redbannerScheduler = exports.redbannerScheduler = {
	  redbannerStartTime: '22:00:00',
	  redbannerEndTime: '23:59:00'
	};
	
	var rowsPerPageOptions = exports.rowsPerPageOptions = [20, 50, 100];
	
	var newBookingApplicationUrl = exports.newBookingApplicationUrl = 'https://gisbookingstage.gapinc.com/';

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.redmineApiKey = exports.redmineDomain = exports.domain = undefined;
	
	var _decrypt_pwd = __webpack_require__(2165);
	
	var domain = exports.domain = '/smee';
	var redmineDomain = exports.redmineDomain = 'https://smeestage.gapinc.com';
	
	var redmineApiKey = exports.redmineApiKey = (0, _decrypt_pwd.ENC)('U2FsdGVkX1+HEyD02h8pcKqBHm92dZW/Yd+KfZdBqI+9JmDJEIEPVuaSSpdRpM8LUpOnG76d/FIJkDMyqf1bvg==');

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefixed = function prefixed(name) {
	  return 'common/' + name;
	};
	var qasPrefixed = function qasPrefixed(name) {
	  return 'qasmanagement/qas/' + name;
	};
	
	var factory = exports.factory = qasPrefixed('getMasterFactoryList');
	var qasVendor = exports.qasVendor = qasPrefixed('getMasterVendorList');
	var qasQARegion = exports.qasQARegion = qasPrefixed('getMasterQARegionList');
	var qasCountryPQA = exports.qasCountryPQA = qasPrefixed('getMasterCountryPQAList');
	var qasAuditStage = exports.qasAuditStage = qasPrefixed('getMasterAuditStageList');
	var qasAuditStatus = exports.qasAuditStatus = qasPrefixed('getAuditStatusList');
	var qasAuditorName = exports.qasAuditorName = qasPrefixed('getAuditorNameList');
	var qasHasMapping = exports.qasHasMapping = qasPrefixed('getHasVendorMapping');
	var qasDefects = exports.qasDefects = qasPrefixed('getDefectList');
	var qasAuditPoint = exports.qasAuditPoint = qasPrefixed('getAuditPointList');
	var qasUserAuditPoint = exports.qasUserAuditPoint = qasPrefixed('userAuditPointList');
	var qasFolder = exports.qasFolder = qasPrefixed('getQasFolder');
	
	var qasLastUser = exports.qasLastUser = qasPrefixed('qasLastUser');
	
	var initialize = exports.initialize = prefixed('initialize');

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getClientUserInactiveTimeout = exports.updateDatatableUserPreferences = exports.getDatatableUserPreferences = undefined;
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _appConfig = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = function url(api) {
	  return _appConfig.microservice.domain + '/common' + api;
	};
	
	var getDatatableUserPreferences = exports.getDatatableUserPreferences = function getDatatableUserPreferences(_ref) {
	  var userSid = _ref.userSid,
	      dataTableCode = _ref.dataTableCode,
	      token = _ref.token;
	
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/dataTablePreferences'), {
	      headers: {
	        'Authorization': 'Bearer ' + token
	      },
	      params: {
	        userSid: userSid,
	        dataTableCode: dataTableCode
	      }
	    }).then(function (response) {
	      if (response.body.userPreferenceJSON) {
	        console.log(response.body.userPreferenceJSON);
	
	        resolve(response.body.userPreferenceJSON);
	      } else {
	        reject({ message: 'No user preference found for data table.' });
	      }
	    }).catch(function (response) {
	      reject({ message: 'Exception occurred when request user preference for data table.' });
	    });
	  });
	};
	
	var updateDatatableUserPreferences = exports.updateDatatableUserPreferences = function updateDatatableUserPreferences(_ref2) {
	  var userSid = _ref2.userSid,
	      dataTableCode = _ref2.dataTableCode,
	      userPreferenceJSON = _ref2.userPreferenceJSON,
	      token = _ref2.token;
	
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.put(url('/dataTablePreferences'), {
	      userSid: userSid,
	      dataTableCode: dataTableCode,
	
	      userPreferenceJSON: userPreferenceJSON
	    }, {
	      headers: {
	        'Authorization': 'Bearer ' + token
	      }
	    }).then(function (response) {
	      resolve();
	    }).catch(function (response) {
	      reject({ message: 'Failed to update data table preferences.' });
	    });
	  });
	};
	
	var getClientUserInactiveTimeout = exports.getClientUserInactiveTimeout = function getClientUserInactiveTimeout(token) {
	  return new _promise2.default(function (resolve, reject) {
	    var headers = { 'content-type': 'application/json', Authorization: 'Bearer ' + token };
	    _vue2.default.http.get(url('/clientUserInactiveTimeout'), {
	      headers: headers
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject({ message: 'Failed to get client user inactive timeout.' });
	    });
	  });
	};

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSearchPanelUserPreferences = exports.getSearchPanelUserPreferences = exports.getVendorMappingList = exports.getVendorGroups = exports.getMills = exports.getVendors = exports.getDepartments = exports.getDivisions = exports.getCountries = exports.getChannels = exports.getMarkets = exports.getSeasons = exports.getYears = exports.getSubCategories = exports.getCategories = exports.getBrands = exports.getHelpMenu = exports.getHelpMenuAll = undefined;
	
	var _stringify = __webpack_require__(186);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _appConfig = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = function url(api) {
	  return _appConfig.microservice.domain + '/common' + api;
	};
	
	var getResource = function getResource(api, token) {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url(api), {
	      headers: {
	        'Authorization': 'Bearer ' + token
	      }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      resolve();
	      reject({
	        message: 'Failed to load resource ' + api
	      });
	    });
	  });
	};
	
	var getHelpMenuAll = exports.getHelpMenuAll = function getHelpMenuAll(_ref) {
	  var userFunctionId = _ref.userFunctionId,
	      token = _ref.token;
	
	  return new _promise2.default(function (resolve, reject) {
	    var headers = { 'content-type': 'application/json', Authorization: 'Bearer ' + token };
	    _vue2.default.http.get(url('/help-menu2'), {
	      headers: headers,
	      params: {
	        userFunctionId: userFunctionId
	      }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject({
	        message: 'Failed to get help menu2.'
	      });
	    });
	  });
	};
	
	var getHelpMenu = exports.getHelpMenu = function getHelpMenu(_ref2) {
	  var userFunctionId = _ref2.userFunctionId,
	      helpMenuDomain = _ref2.helpMenuDomain,
	      token = _ref2.token;
	
	  return new _promise2.default(function (resolve, reject) {
	    var headers = { 'content-type': 'application/json', Authorization: 'Bearer ' + token };
	    _vue2.default.http.get(url('/help-menu'), {
	      headers: headers,
	      params: {
	        userFunctionId: userFunctionId,
	        helpMenuDomain: helpMenuDomain
	      }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject({
	        message: 'Failed to get help menu.'
	      });
	    });
	  });
	};
	
	var getBrands = exports.getBrands = function getBrands(token) {
	  return getResource('/brandList', token);
	};
	
	var getCategories = exports.getCategories = function getCategories(token) {
	  return getResource('/categoryList', token);
	};
	
	var getSubCategories = exports.getSubCategories = function getSubCategories(token) {
	  return getResource('/subCategoryList', token);
	};
	
	var getYears = exports.getYears = function getYears(token) {
	  return getResource('/yearList', token);
	};
	
	var getSeasons = exports.getSeasons = function getSeasons(token) {
	  return getResource('/seasonList', token);
	};
	
	var getMarkets = exports.getMarkets = function getMarkets(token) {
	  return getResource('/marketList', token);
	};
	
	var getChannels = exports.getChannels = function getChannels(token) {
	  return getResource('/channelList', token);
	};
	
	var getCountries = exports.getCountries = function getCountries(token) {
	  return getResource('/countryList', token);
	};
	
	var getDivisions = exports.getDivisions = function getDivisions(token) {
	  return getResource('/divisionList', token);
	};
	
	var getDepartments = exports.getDepartments = function getDepartments(token) {
	  return getResource('/departmentList', token);
	};
	
	var getVendors = exports.getVendors = function getVendors(token) {
	  return getResource('/vendorList', token);
	};
	
	var getMills = exports.getMills = function getMills(token) {
	  return getResource('/millList', token);
	};
	
	var getVendorGroups = exports.getVendorGroups = function getVendorGroups(token) {
	  return getResource('/vendorGroupList', token);
	};
	
	var getVendorMappingList = exports.getVendorMappingList = function getVendorMappingList(_ref3) {
	  var vendorCodeList = _ref3.vendorCodeList,
	      token = _ref3.token;
	
	  return new _promise2.default(function (resolve, reject) {
	    var headers = { 'content-type': 'application/json', Authorization: 'Bearer ' + token };
	    _vue2.default.http.get(url('/vendorMappingList'), {
	      headers: headers,
	      params: {
	        vendorIdList: vendorCodeList.join(',')
	      }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject({
	        message: 'Failed to load resource /vendorMappingList'
	      });
	    });
	  });
	};
	
	var getSearchPanelUserPreferences = exports.getSearchPanelUserPreferences = function getSearchPanelUserPreferences(_ref4) {
	  var userSid = _ref4.userSid,
	      searchPanelCode = _ref4.searchPanelCode,
	      token = _ref4.token;
	
	  return new _promise2.default(function (resolve, reject) {
	    var headers = { 'content-type': 'application/json', Authorization: 'Bearer ' + token };
	    _vue2.default.http.get(url('/searchPanelUserPreferences'), {
	      headers: headers,
	      params: {
	        userSid: userSid,
	        searchPanelCode: searchPanelCode
	      }
	    }).then(function (response) {
	      if (response.body.userPreferenceJSON) {
	        resolve(JSON.parse(response.body.userPreferenceJSON));
	      } else {
	        reject({
	          message: 'Could not find any search panel preference for ' + searchPanelCode
	        });
	      }
	    }).catch(function (response) {
	      reject({
	        message: 'Could not find any search panel preference of ' + searchPanelCode
	      });
	    });
	  });
	};
	
	var updateSearchPanelUserPreferences = exports.updateSearchPanelUserPreferences = function updateSearchPanelUserPreferences(_ref5) {
	  var userSid = _ref5.userSid,
	      searchPanelCode = _ref5.searchPanelCode,
	      userPreferenceJSON = _ref5.userPreferenceJSON,
	      token = _ref5.token;
	
	  return new _promise2.default(function (resolve, reject) {
	    var headers = { 'content-type': 'application/json', Authorization: 'Bearer ' + token };
	    _vue2.default.http.put(url('/searchPanelUserPreferences'), {
	      userSid: userSid,
	      searchPanelCode: searchPanelCode,
	      userPreferenceJSON: (0, _stringify2.default)(userPreferenceJSON)
	    }, { headers: headers }).then(function (resposne) {
	      resolve();
	    }).catch(function (response) {
	      reject({
	        message: 'Failed to update search panel preferences of ' + searchPanelCode
	      });
	    });
	  });
	};

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modules = undefined;
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(17);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _actions = __webpack_require__(2377);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _getters = __webpack_require__(2378);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _mutations = __webpack_require__(2379);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  user: null,
	  alerts: [],
	  isAppJsLoaded: false,
	  clientUserInactiveTimeoutInMinutes: 60,
	  isAppLoading: false,
	  banners: []
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  getters: _getters2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default
	});
	var modules = exports.modules = [];

/***/ }),

/***/ 1617:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefixed = function prefixed(name) {
	  return 'bookingmanagement/' + name;
	};
	
	var donutCriteria = exports.donutCriteria = prefixed('donutCriteria');
	var rainbowCriteria = exports.rainbowCriteria = prefixed('rainbowCriteria');
	var btmSubmitData = exports.btmSubmitData = prefixed('btmSubmitData');
	var bookingChangeCriteria = exports.bookingChangeCriteria = prefixed('bookingChangeCriteria');

/***/ }),

/***/ 1618:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefixed = function prefixed(name) {
	  return 'sourcing_workflow/service_request/' + name;
	};
	
	var PROJECT = exports.PROJECT = prefixed('PROJECT');
	var TYPE_LIST = exports.TYPE_LIST = prefixed('TYPE_LIST');
	var SUB_TYPE_LIST = exports.SUB_TYPE_LIST = prefixed('SUB_TYPE_LIST');
	var STATUS_LIST = exports.STATUS_LIST = prefixed('STATUS_LIST');
	var RESOLUTION_TYPE_LIST = exports.RESOLUTION_TYPE_LIST = prefixed('RESOLUTION_TYPE_LIST');
	
	var TEAM_MEMBER_LIST = exports.TEAM_MEMBER_LIST = prefixed('TEAM_MEMBER_LIST');
	
	var SUBJECT_FIELD = exports.SUBJECT_FIELD = prefixed('SUBJECT_FIELD');
	var TYPE_FIELD = exports.TYPE_FIELD = prefixed('TYPE_FIELD');
	var SUB_TYPE_FIELD = exports.SUB_TYPE_FIELD = prefixed('SUB_TYPE_FIELD');
	var REF_NO_FIELD = exports.REF_NO_FIELD = prefixed('REF_NO_FIELD');
	var STATUS_NOTE_FIELD = exports.STATUS_NOTE_FIELD = prefixed('STATUS_NOTE_FIELD');
	var REF_TYPE_FIELD = exports.REF_TYPE_FIELD = prefixed('REF_TYPE_FIELD');
	var BATCH_ID_FIELD = exports.BATCH_ID_FIELD = prefixed('BATCH_ID_FIELD');
	var DETAIL_FIELD = exports.DETAIL_FIELD = prefixed('DETAIL_FIELD');
	var ASSIGN_TO_FIELD = exports.ASSIGN_TO_FIELD = prefixed('ASSIGN_TO_FIELD');
	var RESOLUTION_FIELD = exports.RESOLUTION_FIELD = prefixed('RESOLUTION_FIELD');
	var RESOLUTION_TYPE_FIELD = exports.RESOLUTION_TYPE_FIELD = prefixed('RESOLUTION_TYPE_FIELD');
	var ASSIGNED_DATE_FIELD = exports.ASSIGNED_DATE_FIELD = prefixed('ASSIGNED_DATE_FIELD');
	var RESOLVED_DATE_FIELD = exports.RESOLVED_DATE_FIELD = prefixed('RESOLVED_DATE_FIELD');
	var SHIP_CANCEL_DATE_FIELD = exports.SHIP_CANCEL_DATE_FIELD = prefixed('SHIP_CANCEL_DATE_FIELD');
	var INDC_DATE_FIELD = exports.INDC_DATE_FIELD = prefixed('INDC_DATE_FIELD');
	var COO_FIELD = exports.COO_FIELD = prefixed('COO_FIELD');
	
	var DEFAULT_PRIORITY = exports.DEFAULT_PRIORITY = prefixed('DEFAULT_PRIORITY');
	var DEFAULT_TRACKER = exports.DEFAULT_TRACKER = prefixed('DEFAULT_TRACKER');
	var DEFAULT_STATUS = exports.DEFAULT_STATUS = prefixed('DEFAULT_STATUS');
	var DEFAULT_TYPE = exports.DEFAULT_TYPE = prefixed('DEFAULT_TYPE');
	var DEFAULT_SUB_TYPE = exports.DEFAULT_SUB_TYPE = prefixed('DEFAULT_SUB_TYPE');
	var DEFAULT_RESOLUTION_TYPE = exports.DEFAULT_RESOLUTION_TYPE = prefixed('DEFAULT_RESOLUTION_TYPE');
	
	var VENDOR_NAME_FIELD = exports.VENDOR_NAME_FIELD = prefixed('VENDOR_NAME_FIELD');
	var VENDOR_NAME2_FIELD = exports.VENDOR_NAME2_FIELD = prefixed('VENDOR_NAME2_FIELD');
	var VENDOR_CODE_FIELD = exports.VENDOR_CODE_FIELD = prefixed('VENDOR_CODE_FIELD');
	
	var IS_TEAM_LEADER = exports.IS_TEAM_LEADER = prefixed('IS_TEAM_LEADER');
	var IS_TEAM_MEMBER = exports.IS_TEAM_MEMBER = prefixed('IS_TEAM_MEMBER');
	var IS_VENDOR = exports.IS_VENDOR = prefixed('IS_VENDOR');
	
	var SHAREPOINT_FOLDER_ID = exports.SHAREPOINT_FOLDER_ID = prefixed('SHAREPOINT_FOLDER_ID');
	
	var ATTACHMENT_INFO_FIELD = exports.ATTACHMENT_INFO_FIELD = prefixed('ATTACHMENT_INFO_FIELD');
	
	var WORKFLOW = exports.WORKFLOW = prefixed('WORKFLOW');
	var WORKFLOW_PERMISSION = exports.WORKFLOW_PERMISSION = prefixed('WORKFLOW_PERMISSION');
	
	var BRAND_FIELD = exports.BRAND_FIELD = prefixed('BRAND_FIELD');
	
	var SET_DROP_DOWN_VALUES = exports.SET_DROP_DOWN_VALUES = prefixed('SET_DROP_DOWN_VALUES');
	var SET_REDMINE_FIELDS = exports.SET_REDMINE_FIELDS = prefixed('SET_REDMINE_FIELDS');
	var SET_REDMINE_DEFAULT_VALUES = exports.SET_REDMINE_DEFAULT_VALUES = prefixed('SET_REDMINE_DEFAULT_VALUES');
	var SET_PROJECT = exports.SET_PROJECT = prefixed('SET_PROJECT');
	var SET_TEAM_MEMBER_LIST = exports.SET_TEAM_MEMBER_LIST = prefixed('SET_TEAM_MEMBER_LIST');
	
	var DROP_DOWN_VALUES_RETRIEVED = exports.DROP_DOWN_VALUES_RETRIEVED = prefixed('DROP_DOWN_VALUES_RETRIEVED');
	var SEARCH_RESULT_LIST = exports.SEARCH_RESULT_LIST = prefixed('SEARCH_RESULT_LIST');
	var SEARCH_RESULT_LIST_SELECTED = exports.SEARCH_RESULT_LIST_SELECTED = prefixed('SEARCH_RESULT_LIST_SELECTED');
	var VENDOR_NAME_TO_ID_MAP = exports.VENDOR_NAME_TO_ID_MAP = prefixed('VENDOR_NAME_TO_ID_MAP');
	var VENDOR_ID_TO_NAME_MAP = exports.VENDOR_ID_TO_NAME_MAP = prefixed('VENDOR_ID_TO_NAME_MAP');
	var TEAM_MEMBER_ID_TO_NAME_MAP = exports.TEAM_MEMBER_ID_TO_NAME_MAP = prefixed('TEAM_MEMBER_ID_TO_NAME_MAP');
	var TEAM_LEADER_EMAIL_MAP = exports.TEAM_LEADER_EMAIL_MAP = prefixed('TEAM_LEADER_EMAIL_MAP');
	var SEARCH_CRITERIA = exports.SEARCH_CRITERIA = prefixed('SEARCH_CRITERIA');
	var REDMINE_ROLE_ID = exports.REDMINE_ROLE_ID = prefixed('REDMINE_ROLE_ID');
	var CUSTOM_FIELD_VISIBILITIES = exports.CUSTOM_FIELD_VISIBILITIES = prefixed('CUSTOM_FIELD_VISIBILITIES');
	var VENDOR_LIST = exports.VENDOR_LIST = prefixed('VENDOR_LIST');
	
	var FETCH_DROP_DOWN_VALUES = exports.FETCH_DROP_DOWN_VALUES = prefixed('FETCH_DROP_DOWN_VALUES');
	var RETRIEVE_PROJECT = exports.RETRIEVE_PROJECT = prefixed('RETRIEVE_PROJECT');
	var GET_SHAREPOINT_FOLDER_ID = exports.GET_SHAREPOINT_FOLDER_ID = prefixed('GET_SHAREPOINT_FOLDER_ID');
	var GET_WORKFLOW = exports.GET_WORKFLOW = prefixed('GET_WORKFLOW');
	var SAVE_SEARCH_CRITERIA = exports.SAVE_SEARCH_CRITERIA = prefixed('SAVE_SEARCH_CRITERIA');
	var GET_VENDOR_LIST = exports.GET_VENDOR_LIST = prefixed('GET_VENDOR_LIST');

/***/ }),

/***/ 1807:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.downloadAttachmentBaseUrl = exports.uploadAttachmentUrl = exports.verifyPO = exports.getVendorHierarchy = exports.getIssueCounts = exports.getWorkflowPermission = exports.getWorkflow = exports.getRedmineRoleId = exports.getSharepointFolderId = exports.getTeamLeader = exports.getVendors = exports.getTeamMembers = exports.url = undefined;
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _app_config = __webpack_require__(322);
	
	var _appConfig = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mstVendorConnectFolderId = _appConfig.smee.sharepoint.mstVendorConnectFolderId.mstVendorConnectFolderId;
	var url = exports.url = function url(api) {
	  return _app_config.domain + api;
	};
	var getTeamMembers = exports.getTeamMembers = function getTeamMembers() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/usermanagement/fetchUserList'), {
	      params: {
	        accessGroupIds: '23'
	      }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject({
	        message: response.body.error || 'Failed'
	      });
	    });
	  });
	};
	
	var getVendors = exports.getVendors = function getVendors() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/usermanagement/fetchUserList'), {
	      params: {
	        accessGroupIds: '24'
	      }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject({
	        message: response.body.error || 'Failed'
	      });
	    });
	  });
	};
	
	var getTeamLeader = exports.getTeamLeader = function getTeamLeader() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/usermanagement/fetchUserList'), {
	      params: {
	        accessGroupIds: '22' }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject({
	        message: response.body.error || 'Failed'
	      });
	    });
	  });
	};
	
	var getSharepointFolderId = exports.getSharepointFolderId = function getSharepointFolderId(params) {
	  return new _promise2.default(function (resolve, reject) {
	    resolve({
	      folderId: mstVendorConnectFolderId
	    });
	  });
	};
	
	var getRedmineRoleId = exports.getRedmineRoleId = function getRedmineRoleId(params) {
	  var token = params.token,
	      accessGroupId = params.accessGroupId;
	
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/redmine/redmine-role-id'), {
	      headers: {
	        'Authorization': 'Bearer ' + token
	      },
	      params: {
	        'access-group-id': accessGroupId
	      }
	    }).then(function (response) {
	      resolve(response.body.redmineRoleId);
	    }).catch(function (response) {
	      reject();
	    });
	  });
	};
	
	var getWorkflow = exports.getWorkflow = function getWorkflow(params) {
	  var trackerId = params.trackerId,
	      roleId = params.roleId,
	      token = params.token;
	
	  if (!trackerId) {
	    trackerId = 1;
	  }
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/redmine/workflow'), {
	      headers: {
	        'Authorization': 'Bearer ' + token
	      },
	      params: {
	        'tracker-id': trackerId,
	        'role-id': roleId
	      }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject();
	    });
	  });
	};
	
	var getWorkflowPermission = exports.getWorkflowPermission = function getWorkflowPermission(params) {
	  var trackerId = params.trackerId,
	      roleId = params.roleId,
	      token = params.token;
	
	  if (!trackerId) {
	    trackerId = 1;
	  }
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/redmine/workflow-permission'), {
	      headers: {
	        'Authorization': 'Bearer ' + token
	      },
	      params: {
	        'tracker-id': trackerId,
	        'role-id': roleId
	      }
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject();
	    });
	  });
	};
	
	var getIssueCounts = exports.getIssueCounts = function getIssueCounts(params) {
	  var token = params.token,
	      projectId = params.projectId,
	      trackerId = params.trackerId,
	      statusIds = params.statusIds,
	      assignTo = params.assignTo;
	
	  var requestParams = {
	    'status-ids': statusIds.join(','),
	    'project-id': projectId,
	    'tracker-id': trackerId
	  };
	  if (assignTo) {
	    requestParams['assign-to'] = assignTo;
	  }
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/redmine/issue-counts'), {
	      headers: {
	        'Authorization': 'Bearer ' + token
	      },
	      params: requestParams
	    }).then(function (response) {
	      resolve(response.body);
	    }).catch(function (response) {
	      reject();
	    });
	  });
	};
	
	var getVendorHierarchy = exports.getVendorHierarchy = function getVendorHierarchy(_ref) {
	  var token = _ref.token,
	      vendorProfileIds = _ref.vendorProfileIds;
	
	  return _vue2.default.http.get(url('/common/vendorHierarchy'), {
	    headers: {
	      'Authorization': 'Bearer ' + token
	    },
	    params: {
	      vendorProfileIds: vendorProfileIds.join(',')
	    }
	  }).then(function (response) {
	    return response.body;
	  });
	};
	
	var verifyPO = exports.verifyPO = function verifyPO(poList, vendorList, token) {
	  return _vue2.default.http.get(url('/common/validatedPoList'), {
	    headers: {
	      'Authorization': 'Bearer ' + token
	    },
	    params: {
	      poList: poList.join(','),
	      vendorCodeList: vendorList.join(',')
	    }
	  });
	};
	
	var uploadAttachmentUrl = exports.uploadAttachmentUrl = url('/sharepoint/files');
	var downloadAttachmentBaseUrl = exports.downloadAttachmentBaseUrl = url('/sharepoint/files/download/');

/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTrackers = exports.getPriorities = exports.getProjects = exports.getStatuses = exports.getCustomFieldMap = exports.getCustomFields = undefined;
	
	var _toConsumableArray2 = __webpack_require__(159);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _app_config = __webpack_require__(322);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = function url(api) {
	  return _app_config.redmineDomain + '/smeeredmine' + api;
	};
	var commonServiceUrl = function commonServiceUrl(api) {
	  return _app_config.domain + '/common' + api;
	};
	
	var requestOptions = {
	  headers: {
	    'X-Redmine-API-Key': _app_config.redmineApiKey
	  }
	};
	
	var rejectResponse = function rejectResponse(reject, response) {
	  var message = response.body || response.body.message || response.body.error || 'Failed';
	  reject({ message: message });
	};
	
	var updateIssueOneByOne = function updateIssueOneByOne(_ref) {
	  var issues = _ref.issues,
	      idx = _ref.idx,
	      oneDone = _ref.oneDone,
	      allDone = _ref.allDone,
	      onFailed = _ref.onFailed;
	
	  if (idx === undefined) {
	    idx = 0;
	  }
	  if (idx < issues.length) {
	    var issue = issues[idx];
	    _vue2.default.http.put(url('/issues/' + issue.id + '.json'), {
	      issue: (0, _extends3.default)({}, issue.data)
	    }, requestOptions).then(function () {
	      oneDone(issue);
	    }).catch(function () {
	      onFailed(issue);
	    }).then(function () {
	      idx++;
	      updateIssueOneByOne({ issues: issues, idx: idx, oneDone: oneDone, allDone: allDone, onFailed: onFailed });
	    });
	  } else {
	    allDone();
	  }
	};
	
	var getCustomFields = exports.getCustomFields = function getCustomFields() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/custom_fields.json'), requestOptions).then(function (response) {
	      var customFields = response.body['custom_fields'].filter(function (customField) {
	        return customField['customized_type'] === 'issue';
	      }).map(function (customField) {
	        var list = customField['possible_values'] ? customField['possible_values'].map(function (item) {
	          return {
	            id: item['value'],
	            name: item['label']
	          };
	        }) : undefined;
	        return {
	          field: customField['id'],
	          name: customField['name'],
	          list: list,
	          defaultValue: customField['default_value']
	        };
	      });
	      var rawCustomFields = response.body['custom_fields'];
	      resolve({
	        customFields: customFields,
	        rawCustomFields: rawCustomFields
	      });
	    }, function (response) {
	      rejectResponse(reject, response);
	    });
	  });
	};
	
	var getCustomFieldMap = exports.getCustomFieldMap = function getCustomFieldMap() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/custom_fields.json'), requestOptions).then(function (response) {
	      var customFieldMap = {};
	      response.body['custom_fields'].forEach(function (customField) {
	        if (customField['customized_type'] === 'issue') {
	          var fieldName = customField['name'];
	          customFieldMap[fieldName] = {
	            id: customField['id']
	          };
	          if (customField['possible_values']) {
	            customFieldMap[fieldName]['values'] = customField['possible_values'];
	          }
	        }
	      });
	      resolve(customFieldMap);
	    }, function (response) {
	      rejectResponse(reject, response);
	    });
	  });
	};
	
	var getStatuses = exports.getStatuses = function getStatuses() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/issue_statuses.json'), requestOptions).then(function (response) {
	      var result = response.body;
	      if (result['issue_statuses']) {
	        var statuses = result['issue_statuses'].map(function (status) {
	          return (0, _extends3.default)({}, status, {
	            isDefault: status.name === 'New',
	            isClosed: status['is_closed'] === true
	          });
	        });
	        resolve(statuses);
	      } else {
	        rejectResponse(reject, response);
	      }
	    }, function (response) {
	      rejectResponse(reject, response);
	    });
	  });
	};
	
	var getProjects = exports.getProjects = function getProjects() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/projects.json'), requestOptions).then(function (response) {
	      var projects = response.body.projects;
	      if (projects) {
	        resolve(projects);
	      } else {
	        rejectResponse(reject, response);
	      }
	    }, function (response) {
	      rejectResponse(reject, response);
	    });
	  });
	};
	
	var getPriorities = exports.getPriorities = function getPriorities() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/enumerations/issue_priorities.json'), requestOptions).then(function (response) {
	      var priorities = response.body['issue_priorities'] ? response.body['issue_priorities'].map(function (priority) {
	        return {
	          id: priority['id'],
	          name: priority['name'],
	          isDefault: priority['is_default'] === true
	        };
	      }) : undefined;
	      if (priorities) {
	        resolve(priorities);
	      } else {
	        rejectResponse(reject, response);
	      }
	    }, function (response) {
	      rejectResponse(reject, response);
	    });
	  });
	};
	
	var getTrackers = exports.getTrackers = function getTrackers() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/trackers.json'), requestOptions).then(function (response) {
	      var trackers = response.body['trackers'] ? response.body['trackers'].map(function (tracker) {
	        return {
	          id: tracker['id'],
	          name: tracker['name'],
	          isDefault: tracker['id'] === tracker['default_status']['id']
	        };
	      }) : undefined;
	      if (trackers) {
	        resolve(trackers);
	      } else {
	        rejectResponse(reject, response);
	      }
	    }, function (response) {
	      rejectResponse(reject, response);
	    });
	  });
	};
	
	exports.default = {
	  created: function created() {
	    var _this = this;
	
	    this.$redmine = {};
	
	    this.$redmine.getCustomFieldMap = getCustomFieldMap;
	
	    this.$redmine.createRequests = function (params) {
	      var promise = new _promise2.default(function (resolve, reject) {
	        var project = params.project;
	        var subject = params.subject;
	        var type = params.type;
	        var subType = params.subType;
	        var refNoList = params.refNoList;
	        var refType = params.refType;
	        var batchId = params.batchId;
	        var detail = params.detail;
	        var tracker = params.tracker;
	        var status = params.status;
	        var priority = params.priority;
	        var vendorName = params.vendorName;
	        var vendorName2 = params.vendorName2;
	        var vendorCode = params.vendorCode;
	        var shipCancelDate = params.shipCancelDate;
	        var indcDate = params.indcDate;
	        var coo = params.coo;
	        var brand = params.brand;
	        var token = params.token;
	        if (refNoList.value.length === 0) {
	          reject();
	        }
	
	        _promise2.default.all([_this.$http.post(url('/batchids.json'), {
	          batchid: {
	            prefix: 'R',
	            base: 1000000
	          }
	        }, requestOptions), _this.$http.get(commonServiceUrl('/poAdditionalInfo'), {
	          headers: {
	            'Authorization': 'Bearer ' + token
	          },
	          params: {
	            poNumbers: refNoList.value.join(',')
	          }
	        })]).then(function (responses) {
	          var result = responses[0].body;
	          var additionalInfoMap = responses[1].body;
	
	          batchId.value = result.batchid.prefix + (result.batchid.base + result.batchid.id);
	
	          var requests = [];
	          refNoList.value.forEach(function (refNo) {
	            var issue = {};
	            var additionalInfo = additionalInfoMap[refNo] || {};
	            issue[project.id] = project.value;
	            issue[subject.id] = refNo + ' ' + subType.value;
	            issue[tracker.id] = tracker.value;
	            issue[status.id] = status.value;
	            issue[priority.id] = priority.value;
	            issue['custom_field_values'] = {};
	            var cf = issue['custom_field_values'];
	            cf[type.id] = type.value;
	            cf[subType.id] = subType.value;
	            cf[refNoList.id] = refNo;
	            cf[refType.id] = refType.value;
	            cf[batchId.id] = batchId.value;
	            cf[detail.id] = detail.value;
	            cf[vendorName.id] = vendorName.value;
	            if (additionalInfo) {
	              cf[vendorName2.id] = additionalInfo.vendorName;
	              cf[vendorCode.id] = additionalInfo.vendorCode;
	              cf[shipCancelDate.id] = additionalInfo.currShipCancelDate;
	              cf[indcDate.id] = additionalInfo.currIndcDate;
	              cf[coo.id] = additionalInfo.coo;
	              cf[brand.id] = additionalInfo.brand;
	            }
	            var request = _this.$http.post(url('/issues.json'), {
	              issue: issue
	            }, requestOptions);
	            requests.push(request);
	          }, _this);
	          _promise2.default.all(requests).then(function (issues) {
	            resolve({
	              issues: issues,
	              batchId: batchId.value
	            });
	          }).catch(function (reason) {
	            reject(reason);
	          });
	        }, function (response) {
	          reject(response);
	        });
	      });
	      return promise;
	    };
	
	    this.$redmine.searchRequests = function (_ref2) {
	      var params = _ref2.params;
	
	      return new _promise2.default(function (resolve, reject) {
	        var api = void 0;
	        var option = void 0;
	        if (params.id) {
	          api = url('/issues/' + params.id + '.json');
	          option = requestOptions;
	        } else {
	          api = url('/issues.json');
	          params = (0, _extends3.default)({}, params, { limit: 100 });
	          option = (0, _extends3.default)({ params: params }, requestOptions);
	        }
	        var getIssues = function getIssues(_ref3) {
	          var offset = _ref3.offset,
	              limit = _ref3.limit;
	
	          var optionCopy = _lodash2.default.cloneDeep(option);
	          optionCopy.params.offset = offset;
	          optionCopy.params.limit = limit;
	          return _vue2.default.http.get(api, optionCopy);
	        };
	        _vue2.default.http.get(api, option).then(function (response) {
	          if (params.id) {
	            resolve([response.body.issue]);
	          } else {
	            var _response$body = response.body,
	                issues = _response$body.issues,
	                limit = _response$body.limit;
	
	            var totalCount = response.body['total_count'];
	            if (issues.length < totalCount) {
	              var requestCount = Math.ceil(totalCount * 1.0 / limit);
	              var requests = [];
	              for (var i = 0; i < requestCount; i++) {
	                requests.push(getIssues({
	                  offset: limit * i,
	                  limit: limit
	                }));
	              }
	              _promise2.default.all(requests).then(function (responses) {
	                var issues = responses.reduce(function (issues, response) {
	                  issues.push.apply(issues, (0, _toConsumableArray3.default)(response.body.issues));
	                  return issues;
	                }, []);
	                resolve(issues);
	              });
	            } else {
	              resolve(issues);
	            }
	          }
	        }).catch(function (response) {
	          resolve([]);
	        });
	      });
	    };
	
	    this.$redmine.retrieveAllIssues = function (_ref4) {
	      var params = _ref4.params;
	
	      var getIssues = function getIssues(_ref5) {
	        var offset = _ref5.offset;
	
	        return _vue2.default.http.get(url('/issues.json'), {
	          params: (0, _extends3.default)({}, params, {
	            offset: offset,
	            limit: 100
	          })
	        });
	      };
	      return new _promise2.default(function (resolve, reject) {
	        getIssues({ offset: 0 }).then(function (response) {
	          var _response$body2 = response.body,
	              issues = _response$body2.issues,
	              limit = _response$body2.limit;
	
	          var totalCount = response.body['total_count'];
	          if (issues.length < totalCount) {
	            var requestCount = Math.ceil(totalCount * 1.0 / limit);
	            var requests = [];
	            for (var i = 0; i < requestCount; i++) {
	              requests.push(getIssues({
	                offset: limit * i
	              }));
	            }
	            _promise2.default.all(requests).then(function (responses) {
	              var issues = responses.reduce(function (issues, response) {
	                issues.push.apply(issues, (0, _toConsumableArray3.default)(response.body.issues));
	                return issues;
	              }, []);
	              resolve(issues);
	            }).catch(function () {
	              reject([]);
	            });
	          } else {
	            resolve(issues);
	          }
	        }).catch(function (response) {
	          reject([]);
	        });
	      });
	    };
	
	    this.$redmine.updateIssues = function (issues) {
	      return new _promise2.default(function (resolve, reject) {
	        var issuesSuccess = [];
	        var issuesFailed = [];
	        updateIssueOneByOne({
	          issues: issues,
	          oneDone: function oneDone(issue) {
	            issuesSuccess.push(issue.id);
	          },
	          onFailed: function onFailed(issue) {
	            issuesFailed.push(issue.id);
	          },
	          allDone: function allDone() {
	            resolve({
	              success: issuesSuccess,
	              failed: issuesFailed
	            });
	          }
	        });
	      });
	    };
	
	    this.$redmine.updateIssue = function (_ref6) {
	      var issue = _ref6.issue;
	
	      return _vue2.default.http.put(url('/issues/' + issue.id + '.json'), {
	        issue: issue.data
	      }, requestOptions);
	    };
	
	    this.$redmine.getIssue = function (_ref7) {
	      var id = _ref7.id;
	
	      return new _promise2.default(function (resolve, reject) {
	        _vue2.default.http.get(url('/issues/' + id + '.json?include=journals'), requestOptions).then(function (response) {
	          resolve(response.body.issue);
	        }).catch(function (response) {
	          reject({ message: response.statusText });
	        });
	      });
	    };
	  }
	};

/***/ }),

/***/ 1842:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefixed = function prefixed(name) {
	  return 'sourcing-workflow/service-request/' + name;
	};
	
	var isTeamLeader = exports.isTeamLeader = prefixed('isTeamLeader');
	var isTeamMember = exports.isTeamMember = prefixed('isTeamMember');
	var isVendor = exports.isVendor = prefixed('isVendor');
	var roleName = exports.roleName = prefixed('roleName');
	var redmineUser = exports.redmineUser = prefixed('redmineUser');
	
	var project = exports.project = prefixed('project');
	
	var initialize = exports.initialize = prefixed('initialize');

/***/ }),

/***/ 2165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ENC = ENC;
	var cryptoJs = __webpack_require__(2789);
	var encKey = ('');
	
	function ENC(data) {
	  var bytes = cryptoJs.AES.decrypt(data, encKey);
	  var decryptedData = bytes.toString(cryptoJs.enc.Utf8);
	  return decryptedData;
	}

/***/ }),

/***/ 2210:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  appNameA: 'Sourcing & Manufacturing',
	  appNameB: 'End-to-End',
	  appShortName: 'SMEE',
	  label: {
	    account: 'Account',
	    add: 'Add',
	    createdBy: 'Created By',
	    createDate: 'Create Date',
	    comment: 'Comment',
	    comments: 'Comments',
	    delete: 'Delete',
	    email: 'Email',
	    failed: 'Failed',
	    from: 'From',
	    mySubscription: 'My Subscription',
	    online: 'Online',
	    or: 'OR',
	    password: 'Password',
	    pleaseSelect: 'Please Select',
	    range: 'Range',
	    reset: 'Reset',
	    resolution: 'Resolution',
	    resolutionType: 'Resolution Type',
	    save: 'Save',
	    search: 'Search',
	    signIn: 'Sign In',
	    singleSignOn: 'Single Sign On',
	    status: 'Status',
	    submit: 'Submit',
	    success: 'Success',
	    to: 'To'
	  },
	  message: {
	    loginHints: 'Sign in to start your session'
	  },
	  menu: {
	    wipMst: 'WIP MST',
	    create: 'Create'
	  }
	};

/***/ }),

/***/ 2214:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),

/***/ 2215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getters = undefined;
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _donutCriteria$rainbo;
	
	var _vuex = __webpack_require__(17);
	
	var _definition = __webpack_require__(1617);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_donutCriteria$rainbo = {}, (0, _defineProperty3.default)(_donutCriteria$rainbo, _definition.donutCriteria, function (state, getters) {
	  return state.donutCriteria;
	}), (0, _defineProperty3.default)(_donutCriteria$rainbo, _definition.rainbowCriteria, function (state, getters) {
	  return state.rainbowCriteria;
	}), (0, _defineProperty3.default)(_donutCriteria$rainbo, _definition.btmSubmitData, function (state, getters) {
	  return state.btmSubmitData;
	}), (0, _defineProperty3.default)(_donutCriteria$rainbo, _definition.bookingChangeCriteria, function (state, getters) {
	  return state.bookingChangeCriteria;
	}), _donutCriteria$rainbo);
	var getters = exports.getters = (0, _vuex.mapGetters)({
	  donutCriteria: _definition.donutCriteria,
	  rainbowCriteria: _definition.rainbowCriteria,
	  btmSubmitData: _definition.btmSubmitData,
	  bookingChangeCriteria: _definition.bookingChangeCriteria
	});

/***/ }),

/***/ 2216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getters = __webpack_require__(2215);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _mutations = __webpack_require__(2217);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(2214);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  donutCriteria: null,
	  rainbowCriteria: null,
	  bookingChangeCriteria: null,
	  btmSubmitData: []
	};
	
	exports.default = {
	  state: state,
	  getters: _getters2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default
	};

/***/ }),

/***/ 2217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _donutCriteria$rainbo;
	
	var _definition = __webpack_require__(1617);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_donutCriteria$rainbo = {}, (0, _defineProperty3.default)(_donutCriteria$rainbo, _definition.donutCriteria, function (state, value) {
	  state.donutCriteria = value;
	}), (0, _defineProperty3.default)(_donutCriteria$rainbo, _definition.rainbowCriteria, function (state, value) {
	  state.rainbowCriteria = value;
	}), (0, _defineProperty3.default)(_donutCriteria$rainbo, _definition.btmSubmitData, function (state, value) {
	  state.btmSubmitData = value;
	}), (0, _defineProperty3.default)(_donutCriteria$rainbo, _definition.bookingChangeCriteria, function (state, value) {
	  state.bookingChangeCriteria = value;
	}), _donutCriteria$rainbo);

/***/ }),

/***/ 2255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = [{
	  url: '/sourcing-wf/commitment-management/commitment-creation-edit',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(69, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3655)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/commitment-management/commitment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3654)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/commitment-management/utilization',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3656)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/commitment-management/utilization-creation-edit',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(67, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3657)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}];

/***/ }),

/***/ 2257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVendorGroupList = undefined;
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(665);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(159);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _preInit$initialize;
	
	var _definition = __webpack_require__(12);
	
	var _service = __webpack_require__(556);
	
	var _definition2 = __webpack_require__(13);
	
	var _common = __webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_preInit$initialize = {}, (0, _defineProperty3.default)(_preInit$initialize, _definition.preInit, function (_ref) {
	  var getters = _ref.getters,
	      commit = _ref.commit;
	
	  var user = getters[_definition2.USER];
	  return new _promise2.default(function (resolve, reject) {
	    _promise2.default.all([(0, _service.getCategories)(user.token), (0, _common.getClientUserInactiveTimeout)(user.token)]).then(function (results) {
	      var _ref2 = [].concat((0, _toConsumableArray3.default)(results)),
	          categoryList = _ref2[0],
	          clientUserInactiveTimeoutInMinutes = _ref2[1];
	
	      if (clientUserInactiveTimeoutInMinutes) {
	        commit(_definition2.CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES, clientUserInactiveTimeoutInMinutes);
	      }
	      if (user.userGroupId === 2) {
	        if (user.categoryCodeList.length > 0) {
	          var userCategoryCodeList = user.categoryCodeList;
	          categoryList = categoryList.filter(function (category) {
	            return userCategoryCodeList.indexOf(category.masterCategoryCode) !== -1;
	          });
	        }
	      }
	      commit(_definition.categories, categoryList);
	      resolve();
	    }).catch(function (_ref3) {
	      var message = _ref3.message;
	
	      reject({ message: message });
	    });
	  });
	}), (0, _defineProperty3.default)(_preInit$initialize, _definition.initialize, function (_ref4) {
	  var getters = _ref4.getters,
	      commit = _ref4.commit;
	
	  return new _promise2.default(function (resolve, reject) {
	    if (!getters[_definition.isLoaded]) {
	      var token = getters[_definition2.USER].token;
	      _promise2.default.all([(0, _service.getBrands)(token), (0, _service.getSubCategories)(token), (0, _service.getYears)(token), (0, _service.getSeasons)(token), (0, _service.getMarkets)(token), (0, _service.getChannels)(token), (0, _service.getCountries)(token), (0, _service.getDivisions)(token), (0, _service.getDepartments)(token), (0, _service.getVendors)(token), (0, _service.getMills)(token), (0, _service.getVendorGroups)(token)]).then(function (resources) {
	        var _resources = (0, _slicedToArray3.default)(resources, 12),
	            brandList = _resources[0],
	            subCategoryList = _resources[1],
	            yearList = _resources[2],
	            seasonList = _resources[3],
	            marketList = _resources[4],
	            channelList = _resources[5],
	            countryList = _resources[6],
	            divisionList = _resources[7],
	            departmentList = _resources[8],
	            vendorList = _resources[9],
	            millList = _resources[10],
	            vendorGroupList = _resources[11];
	
	        new _promise2.default(function (resolve, reject) {
	          var user = getters[_definition2.USER];
	          if (user.userGroupId === 2) {
	            if (user.brandCodeList.length > 0) {
	              var userBrandCodeList = user.brandCodeList;
	              brandList = brandList.filter(function (brand) {
	                return userBrandCodeList.indexOf(brand.code) !== -1;
	              });
	            }
	            resolve();
	          } else if (user.userGroupId === 4) {
	            if (user.vendorList.length > 0) {
	              var vendorCodeList = user.vendorList.map(function (vendor) {
	                return vendor.vendorCode;
	              });
	              (0, _service.getVendorMappingList)({
	                vendorCodeList: vendorCodeList,
	                token: user.token
	              }).then(function (validVendorList) {
	                var map = validVendorList.reduce(function (map, vendor) {
	                  map[vendor.vendorCode] = true;
	                  return map;
	                }, {});
	                vendorList = vendorList.filter(function (vendor) {
	                  return map[vendor.code];
	                });
	                console.info('vendorGroupList');
	                console.info(vendorGroupList);
	                vendorGroupList = getVendorGroupList(vendorGroupList, user.vendorList);
	                console.info(vendorGroupList);
	                resolve();
	              }).catch(function () {
	                vendorList = [];
	                resolve();
	              });
	            } else {
	              vendorList = [];
	              resolve();
	            }
	          } else {
	            resolve();
	          }
	        }).then(function () {
	          commit(_definition.brands, brandList);
	
	          commit(_definition.subCategories, subCategoryList);
	          commit(_definition.years, yearList);
	          commit(_definition.seasons, seasonList);
	          commit(_definition.markets, marketList);
	          commit(_definition.channels, channelList);
	          commit(_definition.countries, countryList);
	          commit(_definition.divisions, divisionList);
	          commit(_definition.departments, departmentList);
	          commit(_definition.vendors, vendorList);
	          commit(_definition.mills, millList);
	          commit(_definition.vendorGroups, vendorGroupList);
	          commit(_definition.isLoaded, true);
	          resolve();
	        }).catch(function (error) {
	          console.log(error);
	          commit(_definition.isLoaded, true);
	        });
	      }).catch(function (_ref5) {
	        var message = _ref5.message;
	
	        reject({ message: message });
	        commit(_definition.isLoaded, true);
	      });
	    }
	  });
	}), _preInit$initialize);
	var getVendorGroupList = exports.getVendorGroupList = function getVendorGroupList(vendorGroupList, vendorList) {
	  console.info('come in');
	  var list = [];
	  vendorGroupList.forEach(function (item) {
	    var isMatch = false;
	    vendorList.forEach(function (itemVendor) {
	      if (item.code === itemVendor.vendorGroupProfileCode) {
	        isMatch = true;
	      }
	    });
	    if (isMatch) {
	      list.push(item);
	    }
	  });
	  return list;
	};

/***/ }),

/***/ 2258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getters = undefined;
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _isLoaded$brands$cate;
	
	var _vuex = __webpack_require__(17);
	
	var _definition = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_isLoaded$brands$cate = {}, (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.isLoaded, function (state, getters) {
	  return state.isLoaded;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.brands, function (state, getters) {
	  return state.brands;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.categories, function (state, getters) {
	  return state.categories;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.subCategories, function (state, getters) {
	  return state.subCategories;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.years, function (state, getters) {
	  return state.years;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.seasons, function (state, getters) {
	  return state.seasons;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.markets, function (state, getters) {
	  return state.markets;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.channels, function (state, getters) {
	  return state.channels;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.countries, function (state, getters) {
	  return state.countries;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.divisions, function (state, getters) {
	  return state.divisions;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.departments, function (state, getters) {
	  return state.departments;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.vendors, function (state, getters) {
	  return state.vendors;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.mills, function (state, getters) {
	  return state.mills;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.vendorGroups, function (state, getters) {
	  return state.vendorGroups;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.searchCriteria, function (state, getters) {
	  return state.searchCriteria;
	}), _isLoaded$brands$cate);
	var getters = exports.getters = (0, _vuex.mapGetters)({
	  isLoaded: _definition.isLoaded,
	  brands: _definition.brands,
	  categories: _definition.categories,
	  subCategories: _definition.subCategories,
	  years: _definition.years,
	  seasons: _definition.seasons,
	  markets: _definition.markets,
	  channels: _definition.channels,
	  countries: _definition.countries,
	  divisions: _definition.divisions,
	  vendors: _definition.vendors,
	  departments: _definition.departments
	});

/***/ }),

/***/ 2259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getters = __webpack_require__(2258);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _mutations = __webpack_require__(2260);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(2257);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  isLoaded: false,
	  brands: [],
	  categories: [],
	  subCategories: [],
	  itemTypes: [],
	  years: [],
	  productTypes: [],
	  seasons: [],
	  markets: [],
	  channels: [],
	  countries: [],
	  divisions: [],
	  departments: [],
	  classes: [],
	  subClasses: [],
	  vendors: [],
	  mills: [],
	  vendorGroups: [],
	  searchCriteria: {
	    capability: null,
	    fabricRdNumber: null,
	    indcDate: null,
	    brands: null,
	    categories: null,
	    subCategories: null,
	    itemTypes: null,
	    year: null,
	    season: null,
	    markets: null,
	    channels: null,
	    countries: null,
	    divisions: null,
	    departments: null,
	    classes: null,
	    subClasses: null,
	    vendors: null,
	    mills: null,
	    status: null,
	    masterStyleNumber: null,
	    styleNumber: null,
	    styleComplex: null,
	    universalStyleNumber: null,
	    vendorGroups: null
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: _getters2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default
	};

/***/ }),

/***/ 2260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _isLoaded$brands$cate;
	
	var _definition = __webpack_require__(12);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortByName = function sortByName(list) {
	  return list.sort(function (a, b) {
	    if (a.name < b.name) {
	      return -1;
	    } else if (a.name > b.name) {
	      return 1;
	    } else {
	      return 0;
	    }
	  });
	};
	
	exports.default = (_isLoaded$brands$cate = {}, (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.isLoaded, function (state, value) {
	  state.isLoaded = value;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.brands, function (state, value) {
	  state.brands = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.categories, function (state, value) {
	  state.categories = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.subCategories, function (state, value) {
	  state.subCategories = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.years, function (state, value) {
	  state.years = value;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.seasons, function (state, value) {
	  state.seasons = value;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.markets, function (state, value) {
	  state.markets = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.channels, function (state, value) {
	  state.channels = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.countries, function (state, value) {
	  state.countries = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.divisions, function (state, value) {
	  state.divisions = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.departments, function (state, value) {
	  state.departments = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.vendors, function (state, value) {
	  state.vendors = sortByName(_lodash2.default.uniqBy(value, 'code'));
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.mills, function (state, value) {
	  state.mills = sortByName(value);
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.vendorGroups, function (state, value) {
	  state.vendorGroups = value;
	}), (0, _defineProperty3.default)(_isLoaded$brands$cate, _definition.searchCriteria, function (state, _ref) {
	  var field = _ref.field,
	      value = _ref.value;
	
	  state.searchCriteria[field] = value;
	}), _isLoaded$brands$cate);

/***/ }),

/***/ 2279:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {};

/***/ }),

/***/ 2280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getters = undefined;
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _factory$qasVendor$qa;
	
	var _vuex = __webpack_require__(17);
	
	var _definition = __webpack_require__(323);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_factory$qasVendor$qa = {}, (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.factory, function (state, getters) {
	  return state.factory;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasVendor, function (state, getters) {
	  return state.qasVendor;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasQARegion, function (state, getters) {
	  return state.qasQARegion;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasCountryPQA, function (state, getters) {
	  return state.qasCountryPQA;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasAuditStage, function (state, getters) {
	  return state.qasAuditStage;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasAuditStatus, function (state, getters) {
	  return state.qasAuditStatus;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasAuditorName, function (state, getters) {
	  return state.qasAuditorName;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasLastUser, function (state, getters) {
	  return state.qasLastUser;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasHasMapping, function (state, getters) {
	  return state.qasHasMapping;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasDefects, function (state, getters) {
	  return state.qasDefects;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasAuditPoint, function (state, getters) {
	  return state.qasAuditPoint;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasUserAuditPoint, function (state, getters) {
	  return state.qasUserAuditPoint;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasFolder, function (state, getters) {
	  return state.qasFolder;
	}), _factory$qasVendor$qa);
	var getters = exports.getters = (0, _vuex.mapGetters)({
	  factory: _definition.factory,
	
	  qasQARegion: _definition.qasQARegion,
	  qasAuditStage: _definition.qasAuditStage,
	  qasAuditStatus: _definition.qasAuditStatus,
	  qasAuditorName: _definition.qasAuditorName,
	  qasLastUser: _definition.qasLastUser,
	  qasHasMapping: _definition.qasHasMapping,
	  qasDefects: _definition.qasDefects,
	  qasAuditPoint: _definition.qasAuditPoint,
	  qasUserAuditPoint: _definition.qasUserAuditPoint,
	  qasFolder: _definition.qasFolder
	});

/***/ }),

/***/ 2281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getters = __webpack_require__(2280);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _mutations = __webpack_require__(2282);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(2279);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  factory: [],
	  qasLastUser: 0,
	  qasFolder: '',
	  qasHasMapping: 'N',
	
	  qasVendor: [],
	  qasQARegion: [],
	  qasCountryPQA: [],
	  qasAuditStage: [],
	  qasAuditStatus: [],
	  qasAuditorName: [],
	  qasDefects: {},
	  qasAuditPoint: [],
	  qasUserAuditPoint: [],
	  searchCriteria: {
	    poDpo: null,
	    factoryCoo: null,
	    factory: null,
	    brand: null,
	    qaRegion: null,
	    countryPqa: null,
	    auditStage: null,
	    auditStatus: null,
	    auditorName: null,
	    auditNum: null,
	    auditType: null
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: _getters2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default
	};

/***/ }),

/***/ 2282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _factory$qasVendor$qa;
	
	var _definition = __webpack_require__(323);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortByName = function sortByName(list) {
	  return list.sort(function (a, b) {
	    if (a.name < b.name) {
	      return -1;
	    } else if (a.name > b.name) {
	      return 1;
	    } else {
	      return 0;
	    }
	  });
	};
	
	var sortByCustomName = function sortByCustomName(list, name) {
	  return list.sort(function (a, b) {
	    if (a[name] < b[name]) {
	      return -1;
	    } else if (a[name] > b[name]) {
	      return 1;
	    } else {
	      return 0;
	    }
	  });
	};
	
	exports.default = (_factory$qasVendor$qa = {}, (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.factory, function (state, value) {
	  state.factory = sortByCustomName(value, 'l_factory_nm');
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasVendor, function (state, value) {
	  state.qasVendor = sortByName(value);
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasQARegion, function (state, value) {
	  state.qasQARegion = sortByCustomName(value, 'pqa_region');
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasCountryPQA, function (state, value) {
	  state.qasCountryPQA = sortByCustomName(value, 'country_pqa');
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasAuditStage, function (state, value) {
	  state.qasAuditStage = sortByName(value);
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasAuditStatus, function (state, value) {
	  state.qasAuditStatus = sortByCustomName(value, 'audit_stauts_name');
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasAuditorName, function (state, value) {
	  state.qasAuditorName = sortByCustomName(value, 'auditor_name');
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.searchCriteria, function (state, _ref) {
	  var field = _ref.field,
	      value = _ref.value;
	
	  state.searchCriteria[field] = value;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasLastUser, function (state, value) {
	  state.qasLastUser = value;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasHasMapping, function (state, value) {
	  state.qasHasMapping = value;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasDefects, function (state, value) {
	  state.qasDefects = value;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasAuditPoint, function (state, value) {
	  state.qasAuditPoint = value;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasUserAuditPoint, function (state, value) {
	  state.qasUserAuditPoint = value;
	}), (0, _defineProperty3.default)(_factory$qasVendor$qa, _definition.qasFolder, function (state, value) {
	  state.qasFolder = value;
	}), _factory$qasVendor$qa);

/***/ }),

/***/ 2322:
/***/ (function(module, exports) {

	"use strict";

/***/ }),

/***/ 2323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getters = undefined;
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _IS_SMS_VENDOR$search;
	
	var _vuex = __webpack_require__(17);
	
	var _definition = __webpack_require__(7);
	
	var _definition2 = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_IS_SMS_VENDOR$search = {}, (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.IS_SMS_VENDOR, function (state, getters) {
	  return getters[_definition2.ACCESS_GROUPS].some(function (accessGroup) {
	    return accessGroup.accessGroup === 'SMS_VENDOR_AD' || accessGroup.accessGroup === 'SMS_VENDOR_DEV_SAMPLE' || accessGroup.accessGroup === 'SMS_VENDOR_COCREATION' || accessGroup.accessGroup === 'SMS_VENDOR_TOP';
	  });
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.searchCriteria, function (state) {
	  return state.smsSearchCriteria;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.productTypes, function (state, getters) {
	  return state.productTypes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.purposes, function (state, getters) {
	  return state.purposes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.sizeModels, function (state, getters) {
	  return state.sizeModels;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.planningPeriods, function (state, getters) {
	  return state.planningPeriods;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.planningYears, function (state, getters) {
	  return state.planningYears;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.shipToAttns, function (state, getters) {
	  return state.shipToAttns;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.classCodes, function (state, getters) {
	  return state.classCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.subClassCodes, function (state, getters) {
	  return state.subClassCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.flowLongDescriptions, function (state, getters) {
	  return state.flowLongDescriptions;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.ssns, function (state, getters) {
	  return state.ssns;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.distros, function (state, getters) {
	  return state.distros;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.gisAgents, function (state, getters) {
	  return state.gisAgents;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.gisAgentCodes, function (state, getters) {
	  return state.gisAgentCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.coos, function (state, getters) {
	  return state.coos;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.inStoreDates, function (state, getters) {
	  return state.inStoreDates;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.brandCodes, function (state, getters) {
	  return state.brandCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.divisionCodes, function (state, getters) {
	  return state.divisionCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.departmentCodes, function (state, getters) {
	  return state.departmentCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.categoryCodes, function (state, getters) {
	  return state.categoryCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.subCategoryCodes, function (state, getters) {
	  return state.subCategoryCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.itemTypes, function (state, getters) {
	  return state.itemTypes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.linePlans, function (state, getters) {
	  return state.linePlans;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.deactivatedPurposes, function (state, getters) {
	  return state.deactivatedPurposes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.deactivatedAdSampleTypes, function (state, getters) {
	  return state.deactivatedAdSampleTypes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.sampleMarkets, function (state, getters) {
	  return state.sampleMarkets;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.plmSampleTypes, function (state, getters) {
	  return state.plmSampleTypes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.marketCodes, function (state, getters) {
	  return state.marketCodes;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.seasonalWorkspace, function (state, getters) {
	  return state.seasonalWorkspace;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.productTeam, function (state, getters) {
	  return state.productTeam;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.requestPurpose, function (state, getters) {
	  return state.requestPurpose;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.rawMaterialType, function (state, getters) {
	  return state.rawMaterialType;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.materialAction, function (state, getters) {
	  return state.materialAction;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.smrStatus, function (state, getters) {
	  return state.smrStatus;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.smrSearchParamsCache, function (state, getters) {
	  return state.smrSearchParamsCache;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.devSearchParamsCache, function (state, getters) {
	  return state.devSearchParamsCache;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.cocCatalogs, function (state, getters) {
	  return state.cocCatalogs;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.svdOffice, function (state, getters) {
	  return state.svdOffice;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.gauge, function (state, getters) {
	  return state.gauge;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.end, function (state, getters) {
	  return state.end;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.roundNum, function (state, getters) {
	  return state.roundNum;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.cocSubCategory, function (state, getters) {
	  return state.cocSubCategory;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.keyCostDriver, function (state, getters) {
	  return state.keyCostDriver;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.cocFabric, function (state, getters) {
	  return state.cocFabric;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.age, function (state, getters) {
	  return state.age;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.gender, function (state, getters) {
	  return state.gender;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.smrOrderingTimeliness, function (state, getters) {
	  return state.smrOrderingTimeliness;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.flowNames, function (state, getters) {
	  return state.flowNames;
	}), (0, _defineProperty3.default)(_IS_SMS_VENDOR$search, _definition.orderingTimelinesss, function (state, getters) {
	  return state.orderingTimelinesss;
	}), _IS_SMS_VENDOR$search);
	var getters = exports.getters = (0, _vuex.mapGetters)({
	  IS_SMS_VENDOR: _definition.IS_SMS_VENDOR,
	  purposes: _definition.purposes,
	  sizeModels: _definition.sizeModels,
	  planningPeriods: _definition.planningPeriods,
	  planningYears: _definition.planningYears,
	  classCodes: _definition.classCodes,
	  subClassCodes: _definition.subClassCodes,
	  flowLongDescriptions: _definition.flowLongDescriptions,
	  ssns: _definition.ssns,
	  distros: _definition.distros,
	  gisAgents: _definition.gisAgents,
	  gisAgentCodes: _definition.gisAgentCodes,
	  coos: _definition.coos,
	  inStoreDates: _definition.inStoreDates,
	  brandCodes: _definition.brandCodes,
	  divisionCodes: _definition.divisionCodes,
	  departmentCodes: _definition.departmentCodes,
	  categoryCodes: _definition.categoryCodes,
	  subCategoryCodes: _definition.subCategoryCodes,
	  itemTypes: _definition.itemTypes,
	  linePlans: _definition.linePlans,
	  shipToAttns: _definition.shipToAttns,
	  deactivatedPurposes: _definition.deactivatedPurposes,
	  deactivatedAdSampleTypes: _definition.deactivatedAdSampleTypes,
	  sampleMarkets: _definition.sampleMarkets,
	  plmSampleTypes: _definition.plmSampleTypes,
	  marketCodes: _definition.marketCodes,
	  seasonalWorkspace: _definition.seasonalWorkspace,
	  productTeam: _definition.productTeam,
	  requestPurpose: _definition.requestPurpose,
	  rawMaterialType: _definition.rawMaterialType,
	  materialAction: _definition.materialAction,
	  smrStatus: _definition.smrStatus,
	  smrSearchParamsCache: _definition.smrSearchParamsCache,
	  devSearchParamsCache: _definition.devSearchParamsCache,
	  cocCatalogs: _definition.cocCatalogs,
	  svdOffice: _definition.svdOffice,
	  gauge: _definition.gauge,
	  end: _definition.end,
	  roundNum: _definition.roundNum,
	  cocSubCategory: _definition.cocSubCategory,
	  keyCostDriver: _definition.keyCostDriver,
	  cocFabric: _definition.cocFabric,
	  age: _definition.age,
	  gender: _definition.gender,
	  smrOrderingTimeliness: _definition.smrOrderingTimeliness,
	  flowNames: _definition.flowNames,
	  orderingTimelinesss: _definition.orderingTimelinesss
	});

/***/ }),

/***/ 2324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getters = __webpack_require__(2323);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _mutations = __webpack_require__(2325);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(2322);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  age: [],
	  brandCodes: [],
	  categoryCodes: [],
	  classCodes: [],
	  cocCatalogs: [],
	  cocSubCategory: [],
	  commitmentActive: null,
	  commitmentExpired: null,
	  commitmentLevel: null,
	  commitmentName: null,
	  commitmentNumber: null,
	  commitmentStatus: null,
	  commitmentType: null,
	  coos: [],
	  deactivatedAdSampleTypes: [],
	  deactivatedPurposes: [],
	  departmentCodes: [],
	  devSearchParamsCache: null,
	  distros: [],
	  divisionCodes: [],
	  fabricDesc: null,
	  fabricType: null,
	  flowLongDescriptions: [],
	  gender: [],
	  gisAgents: [],
	  inStoreDates: [],
	  itemTypes: [],
	  linePlans: [],
	  marketCodes: [],
	  materialAction: [],
	  millCode: null,
	  mouStatus: null,
	  multiDivisionCodes: null,
	  noFilterPurposes: null,
	  planningPeriods: [],
	  planningYears: [],
	  plmSampleTypes: [],
	  productTeam: [],
	  productTypes: [],
	  purposes: [],
	  rawMaterialType: [],
	  rdNumber: null,
	  requestPurpose: [],
	  roundNum: [],
	  sampleMarkets: [],
	  seasonalWorkspace: [],
	  shipToAttns: [],
	  singleGisAgents: null,
	  singlePurposes: null,
	  sizeModels: [],
	  smrSearchParamsCache: null,
	  smrStatus: [],
	  ssns: [],
	  subCategoryCodes: [],
	  subClassCodes: [],
	  toBeApprovedBy: null,
	  utilizationActive: null,
	  utilizationCreatedBy: null,
	  utilizationCreatedDateFrom: null,
	  utilizationCreatedDateTo: null,
	  utilizationLastModifiedBy: null,
	  utilizationLastModifiedDateFrom: null,
	  utilizationLastModifiedDateTo: null,
	  utilizationStatus: null,
	  utilizationToBeApprovedBy: null,
	  flowNames: null,
	  orderingTimelinesss: null,
	  smsSearchCriteria: {
	    purposes: null,
	    singlePurposes: null,
	    noFilterPurposes: null,
	    sizeModels: null,
	    planningPeriods: null,
	    planningYears: null,
	    classCodes: null,
	    subClassCodes: null,
	    flowLongDescriptions: null,
	    flowNames: null,
	    orderingTimelinesss: null,
	    ssns: null,
	    distros: null,
	    gisAgents: null,
	    coos: null,
	    inStoreDates: null,
	    brandCodes: null,
	    divisionCodes: null,
	    departmentCodes: null,
	    categoryCodes: null,
	    subCategoryCodes: null,
	    linePlans: null,
	    deactivatedPurposes: null,
	    deactivatedAdSampleTypes: null,
	    sampleMarkets: null,
	    masterStyleNumber: null,
	    multiDivisionCodes: null,
	    commitmentActive: null,
	    commitmentExpired: null,
	    commitmentLevel: null,
	    commitmentName: null,
	    commitmentNumber: null,
	    commitmentStatus: null,
	    commitmentType: null,
	    fabricDesc: null,
	    fabricType: null,
	    millCode: null,
	    mouStatus: null,
	    rdNumber: null,
	    singleGisAgents: null,
	    toBeApprovedBy: null,
	    utilizationActive: null,
	    utilizationCreatedBy: null,
	    utilizationCreatedDateFrom: null,
	    utilizationCreatedDateTo: null,
	    utilizationLastModifiedBy: null,
	    utilizationLastModifiedDateFrom: null,
	    utilizationLastModifiedDateTo: null,
	    utilizationStatus: null,
	    utilizationToBeApprovedBy: null,
	    marketCodes: null,
	    roundNum: null,
	    cocSubCategory: null,
	    age: null,
	    gender: null,
	    catalog: null,
	    isCommented: null,
	    likeHoldDrop: null,
	    roundNumber: null,
	    vendorRefNum: null,
	    courier: null,
	    smrOrderingTimeliness: null,
	    smrYardageTimeliness: null
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: _getters2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default
	};

/***/ }),

/***/ 2325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _searchCriteria$purpo;
	
	var _definition = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortByName = function sortByName(list) {
	  return list.sort(function (a, b) {
	    if (a.name < b.name) {
	      return -1;
	    } else if (a.name > b.name) {
	      return 1;
	    } else {
	      return 0;
	    }
	  });
	};
	
	exports.default = (_searchCriteria$purpo = {}, (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.searchCriteria, function (state, _ref) {
	  var field = _ref.field,
	      value = _ref.value;
	
	  state.smsSearchCriteria[field] = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.purposes, function (state, value) {
	  state.purposes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.shipToAttns, function (state, value) {
	  state.shipToAttns = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.sizeModels, function (state, value) {
	  state.sizeModels = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.planningPeriods, function (state, value) {
	  state.planningPeriods = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.planningYears, function (state, value) {
	  state.planningYears = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.classCodes, function (state, value) {
	  state.classCodes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.subClassCodes, function (state, value) {
	  state.subClassCodes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.itemTypes, function (state, value) {
	  state.itemTypes = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.productTypes, function (state, value) {
	  state.productTypes = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.flowLongDescriptions, function (state, value) {
	  state.flowLongDescriptions = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.ssns, function (state, value) {
	  state.ssns = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.distros, function (state, value) {
	  state.distros = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.gisAgents, function (state, value) {
	  state.gisAgents = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.gisAgentCodes, function (state, value) {
	  state.gisAgentCodes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.coos, function (state, value) {
	  state.coos = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.inStoreDates, function (state, value) {
	  state.inStoreDates = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.brandCodes, function (state, value) {
	  state.brandCodes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.divisionCodes, function (state, value) {
	  state.divisionCodes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.departmentCodes, function (state, value) {
	  state.departmentCodes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.categoryCodes, function (state, value) {
	  state.categoryCodes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.subCategoryCodes, function (state, value) {
	  state.subCategoryCodes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.linePlans, function (state, value) {
	  state.linePlans = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.deactivatedPurposes, function (state, value) {
	  state.deactivatedPurposes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.deactivatedAdSampleTypes, function (state, value) {
	  state.deactivatedAdSampleTypes = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.sampleMarkets, function (state, value) {
	  state.sampleMarkets = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.plmSampleTypes, function (state, value) {
	  state.plmSampleTypes = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.marketCodes, function (state, value) {
	  state.marketCodes = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.seasonalWorkspace, function (state, value) {
	  state.seasonalWorkspace = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.productTeam, function (state, value) {
	  state.productTeam = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.requestPurpose, function (state, value) {
	  state.requestPurpose = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.rawMaterialType, function (state, value) {
	  state.rawMaterialType = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.materialAction, function (state, value) {
	  state.materialAction = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.smrStatus, function (state, value) {
	  state.smrStatus = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.smrSearchParamsCache, function (state, value) {
	  state.smrSearchParamsCache = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.devSearchParamsCache, function (state, value) {
	  state.devSearchParamsCache = value;
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.cocCatalogs, function (state, value) {
	  state.cocCatalogs = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.svdOffice, function (state, value) {
	  state.svdOffice = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.gauge, function (state, value) {
	  state.gauge = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.end, function (state, value) {
	  state.end = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.roundNum, function (state, value) {
	  state.roundNum = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.cocSubCategory, function (state, value) {
	  state.cocSubCategory = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.keyCostDriver, function (state, value) {
	  state.keyCostDriver = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.cocFabric, function (state, value) {
	  state.cocFabric = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.age, function (state, value) {
	  state.age = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.gender, function (state, value) {
	  state.gender = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.smrOrderingTimeliness, function (state, value) {
	  state.smrOrderingTimeliness = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.flowNames, function (state, value) {
	  state.flowNames = sortByName(value);
	}), (0, _defineProperty3.default)(_searchCriteria$purpo, _definition.orderingTimelinesss, function (state, value) {
	  state.orderingTimelinesss = sortByName(value);
	}), _searchCriteria$purpo);

/***/ }),

/***/ 2327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = [{
	  url: '/SOURCING-WF/Sample-Management/Review-Ad-Sample-Request',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Initiate-Ad-Sample-Request',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1818)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Ad-Sample-Matrix-Rules',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1816)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Manual-Shipment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Update-Shipment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2071)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Search-Shipment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(89, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3803)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Update-Package',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2190)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Search-Package',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(90, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3802)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Generate-Summary-Reports',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2188)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Print-QR-Code',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2189)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Upload-Photos',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2191)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Receive-Shipment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1821)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Configuration',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(68, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3795)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Co-Creation',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3774)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Manual-Shipment/:shipmentId',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Update-Shipment/:shipmentId',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(8/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2071)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Update-Shipment/:shipmentId/:tab',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(8/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2071)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Update-Package/:shippackageId',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(14/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2190)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Config/Print-Packing-List',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(88, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3799)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Config/SearchFilterConfig',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3801)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Config/Configure-Courier',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(95, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3797)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Config/ShipToConfig',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(73, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3804)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Config/StyleCategory',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(74, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3806)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Config/AdDefaultCommentConfig',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(72, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3773)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/QrCode',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(93, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3800)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/PackageIdQrCode',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(94, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3798)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/sample-management/initiate-ad-sample-requests/incomplete-ad',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3826)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/sample-management/receive-shipment/history',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3821)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/sample-management/confirm-receive-and-reorder',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(43, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3796)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/sample-management/ad-hierarchy-not-covered',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3813)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/sample-management/initiate-ad-sample-requests',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(5/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1818)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/sample-management/review-ad-sample-requests',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/sample-management/update-ad-sample-matrix',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(4/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1816)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/Sample-Management/Config/AutoInitAdConfig',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3819)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/sourcing-wf/sample-management/shipment-report',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3805)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}];

/***/ }),

/***/ 2342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMasterData = exports.didUserLoginRedmine = exports.registerMembershipIfNeeded = exports.getProject = exports.getRedmineUser = undefined;
	
	var _toConsumableArray2 = __webpack_require__(159);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(3);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _redmine = __webpack_require__(2375);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRedmineUser = exports.getRedmineUser = function getRedmineUser(user) {
	  return new _promise2.default(function (resolve, reject) {
	    var userLoginId = user.userLoginId,
	        firstName = user.firstName,
	        lastName = user.lastName,
	        emailAddress = user.emailAddress;
	
	    (0, _redmine.getUserByLoginId)(userLoginId).then(function (_ref) {
	      var id = _ref.id;
	
	      (0, _redmine.getUserDetail)(id).then(function (redmineUser) {
	        resolve(redmineUser);
	      }).catch(function (_ref2) {
	        var message = _ref2.message;
	
	        reject({ message: message });
	      });
	    }).catch(function (_ref3) {
	      var message = _ref3.message;
	
	      (0, _redmine.registerUser)({
	        user: {
	          login: userLoginId,
	          firstname: firstName,
	          lastname: lastName,
	          mail: emailAddress,
	          password: '12345678'
	        }
	      }).then(function (_ref4) {
	        var id = _ref4.id;
	
	        (0, _redmine.getUserDetail)(id).then(function (redmineUser) {
	          resolve(redmineUser);
	        }).catch(function (_ref5) {
	          var message = _ref5.message;
	
	          reject({ message: message });
	        });
	      }).catch(function (_ref6) {
	        var message = _ref6.message;
	
	        reject({ message: message });
	      });
	    });
	  });
	};
	
	var getProject = exports.getProject = function getProject() {
	  return new _promise2.default(function (resolve, reject) {
	    (0, _redmine.getProjects)().then(function (projects) {
	      var mst = projects.find(function (project) {
	        return project.identifier === 'wip-mst';
	      });
	      if (mst) {
	        resolve(mst);
	      } else {
	        reject({ message: 'MST does not exist in Redmine.' });
	      }
	    }).catch(function (_ref7) {
	      var message = _ref7.message;
	
	      reject({ message: message });
	    });
	  });
	};
	
	var registerMembershipIfNeeded = exports.registerMembershipIfNeeded = function registerMembershipIfNeeded(_ref8) {
	  var redmineUser = _ref8.redmineUser,
	      project = _ref8.project,
	      roleName = _ref8.roleName;
	
	  return new _promise2.default(function (resolve, reject) {
	    if (redmineUser.memberships.find(function (membership) {
	      return membership.project.id === project.id;
	    })) {
	      resolve(redmineUser);
	    } else {
	      (0, _redmine.getRoles)().then(function (roles) {
	        var role = roles.find(function (role) {
	          return role.name === roleName;
	        });
	        (0, _redmine.registerMembership)({
	          project: project,
	          redmineUser: redmineUser,
	          role: role
	        }).then(function (membership) {
	          redmineUser.memberships.push(_lodash2.default.omit(membership, ['user']));
	          resolve(redmineUser);
	        }).catch(function (_ref9) {
	          var message = _ref9.message;
	
	          reject({ message: message });
	        });
	      }).catch(function (_ref10) {
	        var message = _ref10.message;
	
	        reject({ message: message });
	      });
	    }
	  });
	};
	
	var didUserLoginRedmine = exports.didUserLoginRedmine = function didUserLoginRedmine(redmineUser) {
	  (0, _redmine.updateUserApiKey)(redmineUser['api_key']);
	};
	
	var getMasterData = exports.getMasterData = function getMasterData() {
	  return new _promise2.default(function (resolve, reject) {
	    _promise2.default.all([(0, _redmine.getCustomFields)()]).then(function (masterDataSet) {
	      var _ref11 = [].concat((0, _toConsumableArray3.default)(masterDataSet)),
	          customFields = _ref11[0];
	
	      console.log(customFields);
	    }).catch(function (_ref12) {
	      var message = _ref12.message;
	
	      reject({ message: message });
	    });
	  });
	};

/***/ }),

/***/ 2343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = undefined;
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vuex = __webpack_require__(17);
	
	var _service = __webpack_require__(2342);
	
	var _definition = __webpack_require__(13);
	
	var _definition2 = __webpack_require__(1842);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({}, _definition2.initialize, function (_ref) {
	  var getters = _ref.getters,
	      commit = _ref.commit;
	
	  return new _promise2.default(function (resolve, reject) {
	    if (!getters[_definition2.redmineUser]) {
	      _promise2.default.all([(0, _service.getRedmineUser)(getters[_definition.USER]), (0, _service.getProject)()]).then(function (results) {
	        (0, _service.registerMembershipIfNeeded)({
	          redmineUser: results[0],
	          project: results[1],
	          roleName: getters[_definition2.roleName]
	        }).then(function (redmineUserDetail) {
	          commit(_definition2.redmineUser, redmineUserDetail);
	          commit(_definition2.project, results[1]);
	          (0, _service.didUserLoginRedmine)({ redmineUser: redmineUserDetail });
	          resolve();
	        }).catch(function (_ref2) {
	          var message = _ref2.message;
	
	          reject({ message: message });
	        });
	      }).catch(function (_ref3) {
	        var message = _ref3.message;
	
	        reject({ message: message });
	      });
	    } else {
	      resolve();
	    }
	  });
	});
	var actions = exports.actions = (0, _vuex.mapActions)({
	  initialize: _definition2.initialize
	});

/***/ }),

/***/ 2344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getters = undefined;
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(159);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _isTeamLeader$isTeamM;
	
	var _vuex = __webpack_require__(17);
	
	var _definition = __webpack_require__(1842);
	
	var _definition2 = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkRole = function checkRole(getters, _ref) {
	  var accessRole = _ref.accessRole;
	
	  return getters[_definition2.ACCESS_GROUPS].reduce(function (accessModels, accessGroup) {
	    accessModels.push.apply(accessModels, (0, _toConsumableArray3.default)(accessGroup.accessModelList));
	    return accessModels;
	  }, []).some(function (accessModel) {
	    return accessModel.accessRole === accessRole && accessModel.accessModule === 'SOURCING_WF' && accessModel.accessFunction === 'SERVICE_REQUEST';
	  });
	};
	
	exports.default = (_isTeamLeader$isTeamM = {}, (0, _defineProperty3.default)(_isTeamLeader$isTeamM, _definition.isTeamLeader, function (state, getters) {
	  return checkRole(getters, {
	    accessRole: 'APPROVER'
	  });
	}), (0, _defineProperty3.default)(_isTeamLeader$isTeamM, _definition.isTeamMember, function (state, getters) {
	  return checkRole(getters, {
	    accessRole: 'EDITOR'
	  });
	}), (0, _defineProperty3.default)(_isTeamLeader$isTeamM, _definition.isVendor, function (state, getters) {
	  return checkRole(getters, {
	    accessRole: 'CREATOR'
	  });
	}), (0, _defineProperty3.default)(_isTeamLeader$isTeamM, _definition.roleName, function (state, getters) {
	  return getters[_definition.isTeamLeader] ? 'Team Leader' : getters[_definition.isTeamMember] ? 'Team Member' : getters[_definition.isVendor] ? 'Vendor' : '';
	}), (0, _defineProperty3.default)(_isTeamLeader$isTeamM, _definition.redmineUser, function (state, getters) {
	  return state.redmineUser;
	}), _isTeamLeader$isTeamM);
	var getters = exports.getters = (0, _vuex.mapGetters)({
	  user: _definition2.USER,
	  isTeamLeader: _definition.isTeamLeader,
	  isTeamMember: _definition.isTeamMember,
	  isVendor: _definition.isVendor,
	  roleName: _definition.roleName
	});

/***/ }),

/***/ 2345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getters = __webpack_require__(2344);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _mutations = __webpack_require__(2346);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(2343);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  redmineUser: null,
	  project: null
	};
	
	exports.default = {
	  state: state,
	  getters: _getters2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default
	};

/***/ }),

/***/ 2346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _redmineUser$project;
	
	var _definition = __webpack_require__(1842);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_redmineUser$project = {}, (0, _defineProperty3.default)(_redmineUser$project, _definition.redmineUser, function (state, value) {
	  state.redmineUser = value;
	}), (0, _defineProperty3.default)(_redmineUser$project, _definition.project, function (state, value) {
	  state.project = value;
	}), _redmineUser$project);

/***/ }),

/***/ 2347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(2345);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  modules: {
	    serviceRequest: _index2.default
	  }
	};

/***/ }),

/***/ 2348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(159);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _FETCH_DROP_DOWN_VALU;
	
	var _definition = __webpack_require__(1618);
	
	var _definition2 = __webpack_require__(13);
	
	var _index = __webpack_require__(1809);
	
	var _service = __webpack_require__(1807);
	
	var _service2 = __webpack_require__(556);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listToObject = function listToObject(list) {
	  return list.reduce(function (obj, item) {
	    if (item.isDefault) {
	      obj.defaultValue = item.id;
	    }
	    obj.list.push(item);
	    return obj;
	  }, {
	    list: [],
	    defaultValue: null
	  });
	};
	
	exports.default = (_FETCH_DROP_DOWN_VALU = {}, (0, _defineProperty3.default)(_FETCH_DROP_DOWN_VALU, _definition.FETCH_DROP_DOWN_VALUES, function (_ref) {
	  var getters = _ref.getters,
	      commit = _ref.commit;
	
	  if (!getters[_definition.DROP_DOWN_VALUES_RETRIEVED]) {
	    var user = getters[_definition2.USER];
	    var token = user.token,
	        accessGroupList = user.accessGroupList;
	
	
	    return new _promise2.default(function (resolve, reject) {
	      var mstAccessGroup = accessGroupList.find(function (accessGroup) {
	        return accessGroup.accessGroup.indexOf('SERVICE_REQUEST_') !== -1;
	      });
	      if (!mstAccessGroup) {
	        reject();
	        return;
	      }
	      _promise2.default.all([(0, _index.getCustomFields)(token), (0, _index.getTrackers)(token), (0, _index.getStatuses)(token), (0, _index.getPriorities)(token), (0, _service.getTeamMembers)(), (0, _service.getVendors)(token), (0, _service.getTeamLeader)(), (0, _service.getRedmineRoleId)({
	        token: token,
	        accessGroupId: mstAccessGroup.accessGroupSid
	      })]).then(function (dataSet) {
	        var _ref2 = [].concat((0, _toConsumableArray3.default)(dataSet)),
	            customFieldsResult = _ref2[0],
	            trackers = _ref2[1],
	            statuses = _ref2[2],
	            priorities = _ref2[3],
	            teamMembers = _ref2[4],
	            vendors = _ref2[5],
	            teamLeaders = _ref2[6],
	            roleId = _ref2[7];
	
	        var customFields = customFieldsResult.customFields,
	            rawCustomFields = customFieldsResult.rawCustomFields;
	
	        var customFieldVisibilities = rawCustomFields.filter(function (customField) {
	          return customField.roles.length === 0 || customField.roles.some(function (role) {
	            return role.id === roleId;
	          });
	        }).reduce(function (map, customField) {
	          map[customField.name] = true;
	          return map;
	        }, {});
	        commit(_definition.CUSTOM_FIELD_VISIBILITIES, customFieldVisibilities);
	
	        var customFieldMap = customFields.reduce(function (map, customField) {
	          map[customField.name] = customField;
	          return map;
	        }, {});
	        statuses = statuses.filter(function (status) {
	          return status.name !== 'Closed';
	        });
	        var dropDownValues = (0, _extends3.default)({}, customFieldMap, {
	          tracker: listToObject(trackers),
	          status: listToObject(statuses),
	          priority: listToObject(priorities)
	        });
	        var redmineFields = (0, _extends3.default)({}, customFieldMap);
	        commit(_definition.SET_DROP_DOWN_VALUES, dropDownValues);
	        commit(_definition.SET_REDMINE_FIELDS, redmineFields);
	        commit(_definition.SET_REDMINE_DEFAULT_VALUES, dropDownValues);
	        commit(_definition.DROP_DOWN_VALUES_RETRIEVED);
	        commit(_definition.SET_TEAM_MEMBER_LIST, teamMembers);
	        var vendorNameToIdMap = vendors.reduce(function (map, vendor) {
	          var vendorName = vendor.firstName + ' ' + vendor.lastName;
	          map[vendorName.toLowerCase()] = vendor.id;
	          return map;
	        }, {});
	        var vendorIdToNameMap = vendors.reduce(function (map, vendor) {
	          map[String(vendor.id)] = vendor.firstName + ' ' + vendor.lastName;
	          return map;
	        }, {});
	        var teamMemberIdToNameMap = [].concat((0, _toConsumableArray3.default)(teamMembers), (0, _toConsumableArray3.default)(teamLeaders)).reduce(function (map, teamMember) {
	          map[String(teamMember.id)] = teamMember.firstName + ' ' + teamMember.lastName;
	          return map;
	        }, {});
	        commit(_definition.TEAM_LEADER_EMAIL_MAP, teamLeaders);
	        commit(_definition.VENDOR_NAME_TO_ID_MAP, vendorNameToIdMap);
	        commit(_definition.VENDOR_ID_TO_NAME_MAP, vendorIdToNameMap);
	        commit(_definition.TEAM_MEMBER_ID_TO_NAME_MAP, teamMemberIdToNameMap);
	        resolve();
	      }).catch(function () {
	        reject();
	      });
	    });
	  }
	}), (0, _defineProperty3.default)(_FETCH_DROP_DOWN_VALU, _definition.RETRIEVE_PROJECT, function (_ref3) {
	  var getters = _ref3.getters,
	      commit = _ref3.commit;
	
	  if (!getters[_definition.PROJECT]) {
	    var token = getters[_definition2.USER].token;
	    return (0, _index.getProjects)(token).then(function (projects) {
	      var projectServiceRequest = projects.find(function (project) {
	        return project['identifier'] && project['identifier'] === 'wip-mst';
	      });
	      commit(_definition.SET_PROJECT, projectServiceRequest);
	    });
	  }
	}), (0, _defineProperty3.default)(_FETCH_DROP_DOWN_VALU, _definition.GET_SHAREPOINT_FOLDER_ID, function (_ref4) {
	  var getters = _ref4.getters,
	      commit = _ref4.commit;
	
	  if (!getters[_definition.SHAREPOINT_FOLDER_ID]) {
	    var token = getters[_definition2.USER].token;
	    return (0, _service.getSharepointFolderId)({ token: token }).then(function (_ref5) {
	      var folderId = _ref5.folderId;
	
	      commit(_definition.SHAREPOINT_FOLDER_ID, folderId);
	    });
	  }
	}), (0, _defineProperty3.default)(_FETCH_DROP_DOWN_VALU, _definition.GET_WORKFLOW, function (_ref6) {
	  var getters = _ref6.getters,
	      commit = _ref6.commit;
	
	  if (!getters[_definition.WORKFLOW] || !getters[_definition.WORKFLOW_PERMISSION]) {
	    var user = getters[_definition2.USER];
	    var token = user.token,
	        accessGroupList = user.accessGroupList;
	
	    return new _promise2.default(function (resolve, reject) {
	      var mstAccessGroup = accessGroupList.find(function (accessGroup) {
	        return accessGroup.accessGroup.indexOf('SERVICE_REQUEST_') !== -1;
	      });
	      if (!mstAccessGroup) {
	        reject();
	        return;
	      }
	      (0, _service.getRedmineRoleId)({
	        token: token,
	        accessGroupId: mstAccessGroup.accessGroupSid
	      }).then(function (roleId) {
	        commit(_definition.REDMINE_ROLE_ID, roleId);
	        _promise2.default.all([(0, _service.getWorkflow)({
	          trackerId: 1,
	          roleId: roleId,
	          token: token
	        }), (0, _service.getWorkflowPermission)({
	          trackerId: 1,
	          roleId: roleId,
	          token: token
	        })]).then(function (responses) {
	          commit(_definition.WORKFLOW, responses[0]);
	          commit(_definition.WORKFLOW_PERMISSION, responses[1]);
	          resolve();
	        }).catch(function () {
	          reject();
	        });
	      }).catch(function () {
	        reject();
	      });
	    });
	  }
	}), (0, _defineProperty3.default)(_FETCH_DROP_DOWN_VALU, _definition.SAVE_SEARCH_CRITERIA, function (_ref7, _ref8) {
	  var getters = _ref7.getters,
	      commit = _ref7.commit;
	  var searchCriteria = _ref8.searchCriteria,
	      userSid = _ref8.userSid,
	      searchPanelCode = _ref8.searchPanelCode;
	
	  var token = getters[_definition2.USER].token;
	  commit(_definition.SEARCH_CRITERIA, searchCriteria);
	  (0, _service2.updateSearchPanelUserPreferences)({
	    token: token,
	    userSid: userSid,
	    searchPanelCode: searchPanelCode,
	    userPreferenceJSON: searchCriteria
	  });
	}), (0, _defineProperty3.default)(_FETCH_DROP_DOWN_VALU, _definition.GET_VENDOR_LIST, function (_ref9) {
	  var getters = _ref9.getters,
	      commit = _ref9.commit;
	
	  var vendorList = getters[_definition.VENDOR_LIST];
	  console.log(getters[_definition.IS_VENDOR]);
	  console.log(vendorList);
	  if (getters[_definition.IS_VENDOR] && (!vendorList || vendorList.length === 0)) {
	    var user = getters[_definition2.USER];
	    return (0, _service.getVendorHierarchy)({
	      token: user.token,
	      vendorProfileIds: user.vendorList.map(function (vendor) {
	        return vendor.vendorCode;
	      })
	    }).then(function (result) {
	      var vendorList = result.resource.childVendors;
	      commit(_definition.VENDOR_LIST, vendorList);
	    });
	  }
	}), _FETCH_DROP_DOWN_VALU);

/***/ }),

/***/ 2349:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _PROJECT$TYPE_LIST$SU;
	
	var _definition = __webpack_require__(1618);
	
	var _definition2 = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_PROJECT$TYPE_LIST$SU = {}, (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.PROJECT, function (state) {
	  return state.project.defaultValue ? state.project : null;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.TYPE_LIST, function (state) {
	  return state['Type'].list;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.SUB_TYPE_LIST, function (state) {
	  return state['Sub Type'].list;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.STATUS_LIST, function (state) {
	  return state.status.list;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.TEAM_MEMBER_LIST, function (state) {
	  return state.teamMembers;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.SEARCH_RESULT_LIST, function (state) {
	  return state.searchResultList;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.RESOLUTION_TYPE_LIST, function (state) {
	  return state['Resolution Type'].list;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.SUBJECT_FIELD, function (state) {
	  return state.subject.field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.TYPE_FIELD, function (state) {
	  return state['Type'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.SUB_TYPE_FIELD, function (state) {
	  return state['Sub Type'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.REF_NO_FIELD, function (state) {
	  return state['Ref No'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.REF_TYPE_FIELD, function (state) {
	  return state['Ref Type'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.BATCH_ID_FIELD, function (state) {
	  return state['Batch ID'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.DETAIL_FIELD, function (state) {
	  return state['Detail'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.ASSIGN_TO_FIELD, function (state) {
	  return state['Assign To'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.VENDOR_NAME_FIELD, function (state) {
	  return state['Vendor Name'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.VENDOR_NAME2_FIELD, function (state) {
	  return state['Vendor Name2'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.VENDOR_CODE_FIELD, function (state) {
	  return state['Vendor Code'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.RESOLUTION_FIELD, function (state) {
	  return state['Resolution'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.STATUS_NOTE_FIELD, function (state) {
	  return state['Status Note'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.RESOLUTION_TYPE_FIELD, function (state) {
	  return state['Resolution Type'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.ASSIGNED_DATE_FIELD, function (state) {
	  return state['Assigned Date'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.RESOLVED_DATE_FIELD, function (state) {
	  return state['Resolved Date'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.SHIP_CANCEL_DATE_FIELD, function (state) {
	  return state['Anticipated Ship cancel date'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.INDC_DATE_FIELD, function (state) {
	  return state['INDC Date'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.COO_FIELD, function (state) {
	  return state['COO'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.DROP_DOWN_VALUES_RETRIEVED, function (state) {
	  return state.dropDownValuesRetrieved;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.DEFAULT_PRIORITY, function (state) {
	  var _state$priority = state.priority,
	      field = _state$priority.field,
	      defaultValue = _state$priority.defaultValue;
	
	  return (0, _extends3.default)({ field: field }, state.priority.list.find(function (item) {
	    return item.id === defaultValue;
	  }));
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.DEFAULT_TRACKER, function (state) {
	  var _state$tracker = state.tracker,
	      field = _state$tracker.field,
	      defaultValue = _state$tracker.defaultValue;
	
	  return (0, _extends3.default)({ field: field }, state.tracker.list.find(function (item) {
	    return item.id === defaultValue;
	  }));
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.DEFAULT_STATUS, function (state) {
	  var _state$status = state.status,
	      field = _state$status.field,
	      defaultValue = _state$status.defaultValue;
	
	  return (0, _extends3.default)({ field: field }, state.status.list.find(function (item) {
	    return item.id === defaultValue;
	  }));
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.DEFAULT_TYPE, function (state) {
	  var _state$Type = state['Type'],
	      field = _state$Type.field,
	      defaultValue = _state$Type.defaultValue;
	
	  return (0, _extends3.default)({ field: field }, state['Type'].list.find(function (item) {
	    return item.id === defaultValue;
	  }));
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.DEFAULT_SUB_TYPE, function (state) {
	  var _state$SubType = state['Sub Type'],
	      field = _state$SubType.field,
	      defaultValue = _state$SubType.defaultValue;
	
	  return (0, _extends3.default)({ field: field }, state['Sub Type'].list.find(function (item) {
	    return item.id === defaultValue;
	  }));
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.DEFAULT_RESOLUTION_TYPE, function (state) {
	  var _state$ResolutionTyp = state['Resolution Type'],
	      field = _state$ResolutionTyp.field,
	      defaultValue = _state$ResolutionTyp.defaultValue;
	
	  return (0, _extends3.default)({ field: field }, state['Resolution Type'].list.find(function (item) {
	    return item.id === defaultValue;
	  }));
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.SEARCH_RESULT_LIST_SELECTED, function (state) {
	  return state.searchResultListSelected;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.IS_TEAM_LEADER, function (state, getters) {
	  return getters[_definition2.ACCESS_GROUPS].some(function (accessGroup) {
	    return accessGroup.accessGroup === 'SERVICE_REQUEST_APPROVE';
	  });
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.IS_TEAM_MEMBER, function (state, getters) {
	  return getters[_definition2.ACCESS_GROUPS].some(function (accessGroup) {
	    return accessGroup.accessGroup === 'SERVICE_REQUEST_EDIT';
	  });
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.IS_VENDOR, function (state, getters) {
	  return getters[_definition2.ACCESS_GROUPS].some(function (accessGroup) {
	    return accessGroup.accessGroup === 'SERVICE_REQUEST_CREATE';
	  });
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.VENDOR_NAME_TO_ID_MAP, function (state) {
	  return state.vendorNameToIdMap;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.VENDOR_ID_TO_NAME_MAP, function (state) {
	  return state.vendorIdToNameMap;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.TEAM_MEMBER_ID_TO_NAME_MAP, function (state) {
	  return state.teamMemberIdToNameMap;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.TEAM_LEADER_EMAIL_MAP, function (state) {
	  return state.teamLeaderEmailMap;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.SHAREPOINT_FOLDER_ID, function (state) {
	  return state.sharepointFolderId;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.ATTACHMENT_INFO_FIELD, function (state) {
	  return state['Attachment Info'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.WORKFLOW, function (state) {
	  return state.workflow;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.WORKFLOW_PERMISSION, function (state) {
	  return state.workflowPermission;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.BRAND_FIELD, function (state) {
	  return state['Brand'].field;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.SEARCH_CRITERIA, function (state) {
	  return state.searchCriteria;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.REDMINE_ROLE_ID, function (state) {
	  return state.redmineRoleId;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.CUSTOM_FIELD_VISIBILITIES, function (state) {
	  return state.customFieldVisibilities;
	}), (0, _defineProperty3.default)(_PROJECT$TYPE_LIST$SU, _definition.VENDOR_LIST, function (state) {
	  return state.vendorList;
	}), _PROJECT$TYPE_LIST$SU);

/***/ }),

/***/ 2350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getters = __webpack_require__(2349);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _mutations = __webpack_require__(2351);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(2348);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redmineCustomDropDownMap = ['Type', 'Sub Type', 'Resolution Type'].reduce(function (dropDownMap, name) {
	  dropDownMap[name] = {
	    field: -1,
	    list: [],
	    defaultValue: null
	  };
	  return dropDownMap;
	}, {});
	
	var redmineCustomTextFieldMap = ['Batch ID', 'Ref No', 'Ref Type', 'Detail', 'Assign To', 'Vendor Name', 'Vendor Name2', 'Vendor Code', 'Resolution', 'Status Note', 'Assigned Date', 'Resolved Date', 'Anticipated Ship cancel date', 'INDC Date', 'COO', 'Attachment Info', 'Brand'].reduce(function (textFieldMap, name) {
	  textFieldMap[name] = {
	    field: -1,
	    defaultValue: null
	  };
	  return textFieldMap;
	}, {});
	
	var redmineBuiltInFieldMap = ['project', 'tracker', 'status', 'subject', 'priority'].reduce(function (fieldMap, name) {
	  fieldMap[name] = {
	    field: name + '_id',
	    defaultValue: null
	  };
	  return fieldMap;
	}, {});
	
	redmineBuiltInFieldMap.subject.field = 'subject';
	redmineBuiltInFieldMap.tracker.list = [];
	redmineBuiltInFieldMap.status.list = [];
	redmineBuiltInFieldMap.priority.list = [];
	
	
	var state = (0, _extends3.default)({
	  dropDownValuesRetrieved: false
	}, redmineCustomDropDownMap, redmineCustomTextFieldMap, redmineBuiltInFieldMap, {
	  teamMembers: [],
	  searchResultList: [],
	  searchResultListSelected: [],
	  vendorNameToIdMap: {},
	  vendorIdToNameMap: {},
	  teamLeaderEmailMap: [],
	  sharepointFolderId: null,
	  workflow: null,
	  workflowPermission: null,
	  searchCriteria: null,
	  redmineRoleId: null,
	  customFieldVisibilities: {},
	  vendorList: []
	});
	
	exports.default = {
	  state: state,
	  getters: _getters2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default
	};

/***/ }),

/***/ 2351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _SET_DROP_DOWN_VALUES;
	
	var _definition = __webpack_require__(1618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_SET_DROP_DOWN_VALUES = {}, (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SET_DROP_DOWN_VALUES, function (state, dropDownValues) {
	  for (var property in dropDownValues) {
	    if (state[property] && state[property]['list']) {
	      state[property].list = dropDownValues[property].list;
	    }
	  }
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SET_REDMINE_FIELDS, function (state, redmineFields) {
	  for (var property in redmineFields) {
	    if (state[property] && state[property]['field']) {
	      state[property].field = redmineFields[property].field;
	    }
	  }
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SET_REDMINE_DEFAULT_VALUES, function (state, redmineDefaultValues) {
	  for (var property in redmineDefaultValues) {
	    if (state[property] && state[property]['defaultValue'] === null) {
	      state[property].defaultValue = redmineDefaultValues[property].defaultValue;
	    }
	  }
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.DROP_DOWN_VALUES_RETRIEVED, function (state) {
	  state.dropDownValuesRetrieved = true;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SET_PROJECT, function (state, project) {
	  state.project.defaultValue = project.id;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SET_TEAM_MEMBER_LIST, function (state, teamMembers) {
	  state.teamMembers = teamMembers;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SEARCH_RESULT_LIST, function (state, searchResultList) {
	  state.searchResultList = searchResultList;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SEARCH_RESULT_LIST_SELECTED, function (state, searchResultListSelected) {
	  state.searchResultListSelected = searchResultListSelected;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.VENDOR_NAME_TO_ID_MAP, function (state, vendorNameToIdMap) {
	  state.vendorNameToIdMap = vendorNameToIdMap;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.VENDOR_ID_TO_NAME_MAP, function (state, vendorIdToNameMap) {
	  state.vendorIdToNameMap = vendorIdToNameMap;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.TEAM_MEMBER_ID_TO_NAME_MAP, function (state, teamMemberIdToNameMap) {
	  state.teamMemberIdToNameMap = teamMemberIdToNameMap;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.TEAM_LEADER_EMAIL_MAP, function (state, teamLeaderEmailMap) {
	  state.teamLeaderEmailMap = teamLeaderEmailMap;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SHAREPOINT_FOLDER_ID, function (state, sharepointFolderId) {
	  state.shaepointFolderId = sharepointFolderId;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.WORKFLOW, function (state, workflow) {
	  state.workflow = workflow;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.WORKFLOW_PERMISSION, function (state, workflowPermission) {
	  state.workflowPermission = workflowPermission;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.SEARCH_CRITERIA, function (state, searchCriteria) {
	  state.searchCriteria = searchCriteria;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.REDMINE_ROLE_ID, function (state, redmineRoleId) {
	  state.redmineRoleId = redmineRoleId;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.CUSTOM_FIELD_VISIBILITIES, function (state, customFieldVisibilities) {
	  state.customFieldVisibilities = customFieldVisibilities;
	}), (0, _defineProperty3.default)(_SET_DROP_DOWN_VALUES, _definition.VENDOR_LIST, function (state, value) {
	  state.vendorList = value;
	}), _SET_DROP_DOWN_VALUES);

/***/ }),

/***/ 2352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(2350);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  modules: {
	    serviceRequest: _index2.default
	  }
	};

/***/ }),

/***/ 2373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.axios = undefined;
	
	var _axios = __webpack_require__(2192);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _appConfig = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var axios = _axios2.default.create({
	  baseURL: _appConfig.microservice.domain
	});
	
	exports.axios = axios;

/***/ }),

/***/ 2374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(159);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{
	  url: '/landing-page',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(100, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3574)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/dashboard',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(91, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3844)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/Capacity-Booking-and-RPT/responsive-management/nominate-responsive-products',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2185)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/GIS-WORKFLOW-E2E',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(11/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2185)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/GIS-WORKFLOW-QA',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3747)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/GIS-WORKFLOW-STATIC',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(34, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3759)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/VENDOR-REPORT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(37, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3856)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/SUPERS-REPORT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(52, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3855)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-MULTI-DATA',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(62, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3772)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-MULTI-DATA-VIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(75, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3770)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/BOOKING-MGMT/booking',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/Capacity-Booking-and-RPT/booking-management/Review-Booking',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/BOOKING-MGMT/Vd',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/BOOKING-MGMT/faq-gis',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/Capacity-Booking-and-RPT/booking-management/faq-vendor',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/Capacity-Booking-and-RPT/booking-management/faq-mst',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/BOOKING-MGMT/generatereport',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/BOOKING-MGMT/BTM',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/BOOKING-MGMT/mst-task-assign',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/BOOKING-MGMT/mst-task-update',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/Create-New',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3615)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/Create-New-LDL',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(57, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3616)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/Receipt-Changes',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(55, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3622)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/LDL-Changes',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(61, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3623)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/General-Settings',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(98, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3618)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/Email-Subscription',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(79, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3619)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/FAQ-changemgmt',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(97, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3620)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/Create-New-Step',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(44, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3621)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/Search-Other',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(59, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CHANGE-MGMT/Create-New-PO',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3617)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/PROD-MGMT/Template-Config',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(60, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3695)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/PROD-MGMT/Milestone-Config',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(47, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3693)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/PROD-MGMT/Production-Tracking',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(38, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3696)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/PROD-MGMT/Production-Reporting',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(83, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3694)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/SERVICE-REQUEST/CREATE',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(92, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3831)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/SERVICE-REQUEST/edit/:id',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(87, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3832)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/SERVICE-REQUEST/MST-INTERFACE',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(41, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3833)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}].concat((0, _toConsumableArray3.default)(__webpack_require__(2327)), (0, _toConsumableArray3.default)(__webpack_require__(2255)), [{
	  url: '/SOURCING-WF/Sample-Management/Review-Ad-Sample-Request',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Initiate-Ad-Sample-Request',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(5/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1818)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Ad-Sample-Matrix-Rules',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(4/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1816)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Manual-Shipment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Generate-Summary-Reports',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(12/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2188)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Print-QR-Code',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(10/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2189)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Upload-Photos',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(9/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2191)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/Sample-Management/Receive-Shipment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(6/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1821)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/AD/Init',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(5/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1818)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/AD/View-sample-request',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/AD/Mass-update',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/AD/Matrix-update',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(4/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1816)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/AD/Report-download',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Shipment/Create-AD-shipment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Shipment/Edit-AD-shipment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Shipment/Print-QR-code',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Shipment/Print-packing-list',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Receive/AD',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(6/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1821)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Receive/View-Receiving-history',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(6/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1821)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Receive/Brand-drop',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Receive/Vendor-reject',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Receive/Mass-update',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Receive/Upload-photo',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Receive/Re-order',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SAMPLE-MGMT/Receive/Comment',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-CREATE',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3603)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3600)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE-VIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(54, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3602)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3604)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT-VIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(45, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3606)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3607)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST-VIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(53, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3609)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-REPLACE',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(101, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3614)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE-OVERALL-VIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(56, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3601)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST-OVERALL-VIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(58, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3608)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT-OVERALL-VIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(49, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3605)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-REPLACE-OVERALL',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(102, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3613)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/MASTER-DATA/VPS-EXTENSION/MILL-VENDOR-MASTER',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(40, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3898)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/vps-extension/mill-vendor-master/view-profile/:id',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(84, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3912)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/vps-extension/mill-vendor-master/attribution/:id',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(66, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3899)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/vps-extension/mill-vendor-master/relationship/:id',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(77, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3906)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/MASTER-DATA/VPS-EXTENSION/MILL-FACILITY-PROFILE',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(35, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3890)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/vps-extension/mill-facility-profile/view-profile/:id',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(81, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3886)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/MASTER-DATA/VPS-EXTENSION/MILL-FACILITY-MASTER',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(42, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3871)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/vps-extension/mill-facility-master/attribution/:id',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(65, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3872)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/vps-extension/mill-facility-master/relationship/:id',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(78, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3881)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/MASTER-DATA/VPS-EXTENSION/MANUFACTURING-VENDOR-MASTER',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(36, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3862)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/vps-extension/manufacturing-vendor-master/vendor-master-view',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(71, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3863)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/TEST-REPORT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/DETAIL',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/VIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNAL-TEST-REPORT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNALDETAIL',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNALVIEW',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/report-review',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3836)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/ReportViewBYId',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(63, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3837)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/REPORTVIEWDETAIL',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(82, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3838)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/SEARCH-SHIPMENT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(46, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/SEARCH-AUDIT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(48, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3734)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/CREATE-AUDIT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1815)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/EDIT-AUDIT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(7/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1815)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/COPY-AUDIT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(7/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1815)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/CREATE-CORRELATIONAUDIT',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(7/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1815)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PASS-RATE',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(51, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3729)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PLM',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(50, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3720)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PLM-CHART',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(76, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3730)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/ADMIN/ADMIN',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(70, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3829)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/ADMIN/BATCH-TRIGGER',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3584)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/SOURCING-WF/ADMIN/USER-SUBSCRIPTION',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2184)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/my-settings/my-profile',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(64, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3681)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/my-settings/my-profile/edit',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3682)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/my-settings/user-subscription',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(13/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2184)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  url: '/my-settings/push-notification',
	  file: function file(resolve) {
	    __webpack_require__.e/* require */(80, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(3675)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}]).map(function (route) {
	  return {
	    path: route.url,
	    component: route.file
	  };
	});
	
	exports.default = routes;

/***/ }),

/***/ 2375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTrackers = exports.getCustomFields = exports.registerMembership = exports.getProjects = exports.getUserDetail = exports.getUserByLoginId = exports.getUsers = exports.getRoles = exports.registerUser = exports.updateUserApiKey = undefined;
	
	var _promise = __webpack_require__(15);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(10);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _appConfig = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = function url(api) {
	  return _appConfig.redmine.domain + '/smeeredmine' + api;
	};
	
	var adminRequestOptions = {
	  headers: {
	    'X-Redmine-API-Key': _appConfig.redmine.adminApiKey
	  }
	};
	
	var userRequestOptions = {
	  headers: {
	    'X-Redmine-API-Key': null
	  }
	};
	
	var errorMessage = function errorMessage(response, defaultMessage) {
	  return response.body.error || response.body.errors.join(', ') || defaultMessage + ' Reason: ' + response.statusText;
	};
	
	var updateUserApiKey = exports.updateUserApiKey = function updateUserApiKey(apiKey) {
	  userRequestOptions.headers['X-Redmine-API-Key'] = apiKey;
	};
	
	var updateIssueOneByOne = function updateIssueOneByOne(_ref) {
	  var issues = _ref.issues,
	      idx = _ref.idx,
	      oneDone = _ref.oneDone,
	      allDone = _ref.allDone,
	      onFailed = _ref.onFailed;
	
	  if (idx === undefined) {
	    idx = 0;
	  }
	  if (idx < issues.length) {
	    var issue = issues[idx];
	    _vue2.default.http.put(url('/issues/' + issue.id + '.json'), {
	      issue: (0, _extends3.default)({}, issue.data)
	    }, userRequestOptions).then(function () {
	      oneDone(issue);
	    }).catch(function () {
	      onFailed(issue);
	    }).then(function () {
	      idx++;
	      updateIssueOneByOne({ issues: issues, idx: idx, oneDone: oneDone, allDone: allDone, onFailed: onFailed });
	    });
	  } else {
	    allDone();
	  }
	};
	
	var registerUser = exports.registerUser = function registerUser(params) {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.post(url('/users.json'), params, adminRequestOptions).then(function (response) {
	      resolve(response.body.user);
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, '(Redmine) Failed to register user.') });
	    });
	  });
	};
	
	var getRoles = exports.getRoles = function getRoles() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/roles.json'), adminRequestOptions).then(function (response) {
	      var roles = response.body.roles;
	      resolve(roles);
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, '(Redmine) Failed to get roles.') });
	    });
	  });
	};
	
	var getUsers = exports.getUsers = function getUsers() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/users.json'), adminRequestOptions).then(function (response) {
	      resolve(response.body.users);
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, '(Redmine) Failed to retrieve all users.') });
	    });
	  });
	};
	
	var getUserByLoginId = exports.getUserByLoginId = function getUserByLoginId(loginId) {
	  return new _promise2.default(function (resolve, reject) {
	    var options = (0, _extends3.default)({}, adminRequestOptions, {
	      params: {
	        name: loginId
	      }
	    });
	    _vue2.default.http.get(url('/users.json'), options).then(function (response) {
	      var user = response.body.users.find(function (user) {
	        return user.login === loginId;
	      });
	      if (user) {
	        resolve(user);
	      } else {
	        reject({ message: 'User not found' });
	      }
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, '(Redmine) Failed to get user by login ID.') });
	    });
	  });
	};
	
	var getUserDetail = exports.getUserDetail = function getUserDetail(userId) {
	  return new _promise2.default(function (resolve, reject) {
	    var options = (0, _extends3.default)({}, adminRequestOptions, {
	      params: {
	        include: 'memberships'
	      }
	    });
	    _vue2.default.http.get(url('/users/' + userId + '.json'), options).then(function (response) {
	      var user = response.body.user;
	      if (user) {
	        resolve(user);
	      } else {
	        reject({ message: 'User not found' });
	      }
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, '(Redmine) Failed to get user with memberships.') });
	    });
	  });
	};
	
	var getProjects = exports.getProjects = function getProjects() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/projects.json'), adminRequestOptions).then(function (response) {
	      resolve(response.body.projects);
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, 'Failed to get projects.') });
	    });
	  });
	};
	
	var registerMembership = exports.registerMembership = function registerMembership(_ref2) {
	  var project = _ref2.project,
	      redmineUser = _ref2.redmineUser,
	      role = _ref2.role;
	
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.post(url('/projects/' + project.id + '/memberships.json'), {
	      membership: {
	        'user_id': redmineUser.id,
	        'role_ids': [role.id]
	      }
	    }, adminRequestOptions).then(function (response) {
	      resolve(response.body.membership);
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, '(Redmine) Failed to register membership.') });
	    });
	  });
	};
	
	var getCustomFields = exports.getCustomFields = function getCustomFields() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/custom_fields.json'), adminRequestOptions).then(function (response) {
	      resolve(response.body['custom_fields']);
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, '(Redmine) Failed to get custom fileds.') });
	    });
	  });
	};
	
	var getTrackers = exports.getTrackers = function getTrackers() {
	  return new _promise2.default(function (resolve, reject) {
	    _vue2.default.http.get(url('/trackers.json'), adminRequestOptions).then(function (response) {
	      resolve(response.body.trackers);
	    }).catch(function (response) {
	      reject({ message: errorMessage(response, '(Redmine) Failed to get trackers.') });
	    });
	  });
	};

/***/ }),

/***/ 2377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _regenerator = __webpack_require__(1425);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(1424);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _request$retrieveAcce;
	
	var _definition = __webpack_require__(13);
	
	var _definition2 = __webpack_require__(12);
	
	var _store = __webpack_require__(2352);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _store3 = __webpack_require__(2347);
	
	var _store4 = _interopRequireDefault(_store3);
	
	var _index = __webpack_require__(2259);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(2281);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(2324);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _store5 = __webpack_require__(2216);
	
	var _store6 = _interopRequireDefault(_store5);
	
	var _axios = __webpack_require__(2373);
	
	var _qs = __webpack_require__(3525);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _index7 = __webpack_require__(1356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var auth = function auth(params) {
	  return _axios.axios.post('/oauth/token', _qs2.default.stringify(params), {
	    auth: {
	      username: 'smee-web',
	      password: 'smee-web-secret'
	    },
	    headers: {
	      'Content-Type': 'application/x-www-form-urlencoded'
	    }
	  });
	};
	
	var invalidCredentialsError = function invalidCredentialsError(message) {
	  return {
	    name: 'invalid_credentials',
	    message: message
	  };
	};
	
	var retrieveAccessToken = function retrieveAccessToken(_ref, credentials) {
	  var getters = _ref.getters,
	      commit = _ref.commit;
	
	  var userName = null;
	  var password = null;
	  var refreshToken = null;
	  if (credentials) {
	    userName = credentials.userName;
	    password = credentials.password;
	    refreshToken = credentials.refreshToken;
	  }
	  if ((!userName || !password) && !refreshToken) {
	    refreshToken = getters.user.refreshToken;
	    if (!refreshToken) {
	      throw invalidCredentialsError('Cannot find any user name, password or refresh token.');
	    }
	  }
	  var params = refreshToken ? {
	    'grant_type': 'refresh_token',
	    'refresh_token': refreshToken
	  } : {
	    'grant_type': 'password',
	    username: userName,
	    password: password,
	    scope: 'write'
	  };
	  return auth(params).then(function (response) {
	    var data = response.data;
	    commit('tokens', {
	      accessToken: data['access_token'],
	      refreshToken: data['refresh_token'],
	      tokenType: data['token_type']
	    });
	  });
	};
	
	var requestConfig = function requestConfig(_ref2) {
	  var api = _ref2.api,
	      method = _ref2.method,
	      data = _ref2.data,
	      getters = _ref2.getters;
	
	  if (!method) {
	    method = 'GET';
	  }
	  var config = {
	    url: api,
	    method: method,
	    headers: {
	      'Content-Type': 'application/json',
	      'Authorization': 'Bearer' + ' ' + getters[_definition.USER].token
	    }
	  };
	  if (data) {
	    config[method.toLowerCase() === 'get' ? 'params' : 'data'] = data;
	  }
	  return config;
	};
	
	var isAccessTokenExpired = function isAccessTokenExpired(error) {
	  if (error && error.response && error.response.data) {
	    var responseData = error.response.data;
	    if (responseData.error === 'invalid_token') {
	      return responseData['error_description'] && responseData['error_description'].startsWith('Access token expired');
	    }
	  }
	  return false;
	};
	
	var request = function () {
	  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref4, _ref5) {
	    var getters = _ref4.getters,
	        commit = _ref4.commit,
	        dispatch = _ref4.dispatch;
	    var api = _ref5.api,
	        method = _ref5.method,
	        data = _ref5.data;
	
	    var _ref6, _ref6$error, error, _ref6$response, response;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _axios.axios.request(requestConfig({ api: api, method: method, data: data, getters: getters })).then(function (response) {
	              return { response: response };
	            }).catch(function (error) {
	              return { error: error };
	            });
	
	          case 2:
	            _ref6 = _context.sent;
	            _ref6$error = _ref6.error;
	            error = _ref6$error === undefined ? null : _ref6$error;
	            _ref6$response = _ref6.response;
	            response = _ref6$response === undefined ? null : _ref6$response;
	
	            if (isAccessTokenExpired(error)) {}
	            if (!error && !response) {
	              response = _axios.axios.request(requestConfig({ api: api, method: method, data: data, getters: getters }));
	            }
	
	            if (response) {
	              _context.next = 11;
	              break;
	            }
	
	            throw error;
	
	          case 11:
	            return _context.abrupt('return', response);
	
	          case 12:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function request(_x, _x2) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	exports.default = (_request$retrieveAcce = {
	  request: request,
	  retrieveAccessToken: retrieveAccessToken
	}, (0, _defineProperty3.default)(_request$retrieveAcce, _definition.INIT_STATE, function (_ref7, _ref8) {
	  var dispatch = _ref7.dispatch,
	      commit = _ref7.commit;
	  var user = _ref8.user,
	      store = _ref8.store;
	
	  commit(_definition.SET_USER, user);
	  store.registerModule('sourcingWorkflow', _store2.default);
	  store.registerModule('sourcingWorkflow2', _store4.default);
	  store.registerModule('common', _index2.default);
	  store.registerModule('qas', _index4.default);
	  store.registerModule('samplemanagement', _index6.default);
	  store.registerModule('bookingStore', _store6.default);
	  return dispatch(_definition2.preInit);
	}), (0, _defineProperty3.default)(_request$retrieveAcce, _definition.RELEASE_STATE, function (_ref9, _ref10) {
	  var commit = _ref9.commit,
	      getters = _ref9.getters;
	  var store = _ref10.store;
	
	  if (getters[_definition.USER] !== null) {
	    commit(_definition.SET_USER, null);
	    store.unregisterModule('sourcingWorkflow');
	    store.unregisterModule('sourcingWorkflow2');
	    store.unregisterModule('common');
	    store.unregisterModule('qas');
	    store.unregisterModule('samplemanagement');
	    store.unregisterModule('bookingStore');
	    _index7.modules.forEach(function (module) {
	      store.unregisterModule(module);
	    });
	  }
	}), (0, _defineProperty3.default)(_request$retrieveAcce, _definition.ALERT_SUCCESS, function (_ref11, _ref12) {
	  var dispatch = _ref11.dispatch;
	  var message = _ref12.message;
	
	  dispatch(_definition.ALERT_AUTO_DISMISS, {
	    message: message,
	    css: 'alert-success'
	  });
	}), (0, _defineProperty3.default)(_request$retrieveAcce, _definition.ALERT_INFO, function (_ref13, _ref14) {
	  var dispatch = _ref13.dispatch;
	  var message = _ref14.message;
	
	  dispatch(_definition.ALERT_AUTO_DISMISS, {
	    message: message,
	    css: 'alert-info'
	  });
	}), (0, _defineProperty3.default)(_request$retrieveAcce, _definition.ALERT_WARNING, function (_ref15, _ref16) {
	  var dispatch = _ref15.dispatch;
	  var message = _ref16.message;
	
	  dispatch(_definition.ALERT_AUTO_DISMISS, {
	    message: message,
	    css: 'alert-warning'
	  });
	}), (0, _defineProperty3.default)(_request$retrieveAcce, _definition.ALERT_DANGER, function (_ref17, _ref18) {
	  var dispatch = _ref17.dispatch;
	  var message = _ref18.message;
	
	  dispatch(_definition.ALERT_AUTO_DISMISS, {
	    message: message,
	    css: 'alert-danger'
	  });
	}), (0, _defineProperty3.default)(_request$retrieveAcce, _definition.ALERT_AUTO_DISMISS, function (_ref19, alert) {
	  var commit = _ref19.commit;
	
	  commit(_definition.ADD_ALERT, alert);
	  setTimeout(function () {
	    commit(_definition.REMOVE_ALERT, alert);
	  }, 6000);
	}), _request$retrieveAcce);

/***/ }),

/***/ 2378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _map = __webpack_require__(2167);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _toConsumableArray2 = __webpack_require__(159);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _banners$ALERTS$USER$;
	
	var _definition = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pagesDoNotShowOnMenu = {
	  'SOURCING_WF': {
	    'SERVICE_REQUEST': {
	      'DETAIL': ['ADMINISTRATOR', 'APPROVER', 'CREATOR', 'EDITOR', 'VIEWER'],
	      'CREATE': ['ADMINISTRATOR', 'APPROVER', 'EDITOR', 'VIEWER']
	    }
	  }
	};
	
	var sag = ['SMS_ADMIN', 'SMS_HELPDESK', 'SMS_BRAND_AD_GEN', 'SMS_BRAND_AD_REVIEW', 'SMS_AD_RECEIVER', 'SMS_BRAND_DEV_SAMPLE', 'SMS_GIS_AD', 'SMS_GIS_DEV_SAMPLE', 'SMS_GIS_SMR', 'SMS_VENDOR_AD', 'SMS_VENDOR_DEV_SAMPLE', 'SMS_VENDOR_SMR', 'SMS_BRAND_SMR', 'SMS_GIS_COCREATION', 'SMS_VENDOR_COCREATION', 'SMS_BRAND_COCREATION', 'SMS_BRAND_TOP', 'SMS_GIS_TOP', 'SMS_VENDOR_TOP', 'TRIM_SUPPLIER'];
	
	var accessGroupLimited = {
	  'initiate-ad-sample-requests': {
	    'create': [sag[0], sag[2]]
	  },
	  'initiate-top-sample-requests': {
	    'create': [sag[0], sag[16]]
	  },
	  'review-ad-sample-requests': {
	    'brandDrop': [sag[0], sag[1], sag[2], sag[16]],
	    'vendorReject': [sag[0], sag[1], sag[9], sag[18]],
	    'massUpdateBrandSampleDueDate': [sag[0], sag[1], sag[9], sag[16]],
	    'massUpdateBrand': [sag[0], sag[1], sag[2], sag[6], sag[16], sag[17]],
	    'massUpdateBrandSize': [sag[0], sag[1], sag[2], sag[16]],
	    'massUpdateBrandQty': [sag[0], sag[1], sag[2], sag[16]],
	    'massUpdateBrandShipTo': [sag[0], sag[1], sag[2], sag[16]],
	    'massUpdateBrandComment': [sag[0], sag[1], sag[2], sag[6], sag[16], sag[17]],
	    'massUpdateBorrowAndHandOff': [sag[0], sag[1], sag[2]],
	    'massUpdateBrandIsPriority': [sag[0], sag[1], sag[2], sag[16]],
	    'massUpdateAmendmentReason': [sag[0], sag[1], sag[2], sag[16]],
	    'massUpdateVender': [sag[0], sag[8], sag[9], sag[10], sag[11], sag[18]],
	    'massUpdateVenderDate': [sag[0], sag[9], sag[18]],
	    'massUpdateVenderLate': [sag[0], sag[9], sag[18]],
	    'massUpdateVenderComment': [sag[0], sag[8], sag[9], sag[10], sag[11], sag[18]],
	    'photoUpload': [sag[0], sag[2], sag[9], sag[16], sag[18]],
	    'reportExport': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[6], sag[9], sag[16], sag[17], sag[18]],
	    'comment': [sag[0], sag[2], sag[6], sag[9], sag[16], sag[17], sag[18]],
	    'reorder': [sag[0], sag[1], sag[2], sag[16]],
	    'printQrCode': [sag[0], sag[2], sag[3], sag[1], sag[9], sag[16], sag[18]],
	    'printPackingList': [sag[0], sag[1], sag[9], sag[18]],
	    'create': [sag[0], sag[1], sag[2], sag[6], sag[7], sag[8], sag[9], sag[16], sag[17], sag[18]],
	    'addSize': [sag[0], sag[1], sag[2], sag[16]],
	    'getVendorFilter': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[6], sag[7], sag[8], sag[12], sag[16], sag[17]],
	    'shipmentReport': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[12], sag[13], sag[14], sag[15], sag[16]]
	  },
	  'shipment-report': {
	    'getVendorFilter': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[6], sag[7], sag[8], sag[12]]
	  },
	  'update-ad-sample-matrix': {
	    'block-downloadTemplate': [sag[2], sag[3], sag[4], sag[6], sag[9], sag[16], sag[17], sag[18]],
	    'create': [sag[0], sag[2], sag[16]]
	  },
	  'review-dev-sample-requests': {
	    'create': [sag[0]],
	    'exportAll': [sag[0]],
	    'reportExport': [sag[0], sag[5], sag[7], sag[10]],
	    'massUpdateBrand': [sag[0], sag[1], sag[2], sag[6]],
	    'massUpdateVender': [sag[0], sag[7], sag[10]],
	    'photoUpload': [sag[0], sag[10]],
	    'comment': [sag[0], sag[5], sag[7], sag[10]],
	    'printQrCode': [sag[0], sag[1], sag[10]],
	    'printPackingList': [sag[0], sag[1], sag[5], sag[7], sag[10]],
	    'search': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[6], sag[7], sag[9], sag[10], sag[13], sag[14]],
	    'getVendorFilter': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[5], sag[6], sag[7], sag[8], sag[12]],
	    'viewRelatedSMR': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[10], sag[11], sag[12]]
	  },
	  'review-smr': {
	    'view': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[10], sag[11], sag[12], sag[19]],
	    'search': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[11], sag[12], sag[19]],
	    'massUpdateFlag': [sag[0], sag[8], sag[11], sag[19]],
	    'massUpdate': [sag[0], sag[8], sag[11], sag[19]],
	    'viewRelatedDev': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[10], sag[11], sag[12], sag[19]],
	    'commentRead': [sag[0], sag[1], sag[5], sag[7], sag[8], sag[11], sag[12], sag[19]],
	    'commentWrite': [sag[0], sag[8], sag[11], sag[12], sag[19]],
	    'photoUpload': [sag[0], sag[8], sag[11], sag[19]]
	  },
	  'manual-shipment': {
	    'ad-shipment': [sag[0], sag[1], sag[2], sag[3], sag[6], sag[9]],
	    'dev-shipment': [sag[0], sag[1], sag[5], sag[7], sag[10]],
	    'smr-read': [sag[0], sag[1], sag[2], sag[3], sag[8], sag[11], sag[19]],
	    'smr-write': [sag[0], sag[1], sag[8], sag[11], sag[19]],
	    'modify': [sag[0], sag[1], sag[6], sag[7], sag[8], sag[9], sag[10], sag[11], sag[19]],
	    'create': [sag[0], sag[1], sag[6], sag[7], sag[8], sag[9], sag[10], sag[11], sag[19]]
	  },
	  'update-shipment': {
	    'ad-shipment': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[6], sag[9]],
	    'top-shipment': [sag[0], sag[1], sag[16], sag[17], sag[18]],
	    'dev-shipment': [sag[0], sag[1], sag[5], sag[7], sag[10]],
	    'smr-read': [sag[0], sag[1], sag[2], sag[3], sag[8], sag[11], sag[12], sag[19]],
	    'smr-write': [sag[0], sag[1], sag[8], sag[11], sag[19]],
	    'smr-edit': [sag[0], sag[1], sag[8], sag[11], sag[19]],
	    'create': [sag[0], sag[1], sag[6], sag[7], sag[8], sag[9], sag[10], sag[11], sag[17], sag[18], sag[19]],
	    'scan-and-pack': [sag[0], sag[1], sag[9]]
	  },
	  'search-shipment': {
	    'ad-shipment': [sag[0], sag[1], sag[2], sag[3], sag[6], sag[9]],
	    'top-shipment': [sag[0], sag[1], sag[16], sag[17], sag[18]],
	    'dev-shipment': [sag[0], sag[1], sag[5], sag[7], sag[10]],
	    'smr-shipment': [sag[0], sag[1], sag[2], sag[3], sag[8], sag[11], sag[12], sag[19]],
	    'smr-bypass': [sag[0], sag[1], sag[8], sag[12]],
	    'scan-and-pack': [sag[0], sag[1], sag[9]]
	  },
	  'update-package': {
	    'ad-shipment': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[6], sag[9]],
	    'top-shipment': [sag[0], sag[1], sag[16], sag[17], sag[18]],
	    'dev-shipment': [sag[0], sag[1], sag[5], sag[7], sag[10]],
	    'smr-read': [sag[0], sag[1], sag[2], sag[3], sag[8], sag[11], sag[12], sag[19]],
	    'create': [sag[0], sag[1], sag[9]]
	  },
	  'generate-summary-reports': {
	    'create': [sag[0], sag[1], sag[2], sag[3], sag[4], sag[6], sag[9]]
	  },
	  'receive-shipment': {
	    'create': [sag[0], sag[1], sag[2], sag[4], sag[5], sag[6], sag[16], sag[17]],
	    'confirmReceiveAndReorder': [sag[0], sag[2], sag[3], sag[4], sag[16]]
	  },
	  'co-creation': {
	    'view': [sag[0], sag[13], sag[14], sag[15]],
	    'createFabric': [sag[0], sag[13], sag[14]],
	    'createProduct': [sag[0], sag[13], sag[14]],
	    'createCatalog': [sag[0], sag[13], sag[14]],
	    'batchUpload': [sag[0], sag[13], sag[14]],
	    'photoUpload': [sag[0], sag[13], sag[14]],
	    'downloadTemplate': [sag[0], sag[13], sag[14]],
	    'downloadReport': [sag[0], sag[14], sag[15]],
	    'cardPrinting': [sag[0], sag[14], sag[15]],
	    'massUpdateBrand': [sag[0], sag[15]],
	    'massUpdateVendor': [sag[0], sag[13], sag[14]],
	    'vendor': [sag[14]],
	    'addToCatalog': [sag[0], sag[13], sag[14]]
	  },
	  'configure-courier': {
	    'view': [sag[0]],
	    'create': [sag[0]]
	  },
	  'purpose-config': {
	    'create': [sag[0]]
	  },
	  'searchfilterconfig': {
	    'create': [sag[0]]
	  },
	  'configuration': {
	    'view': [sag[0], sag[1]],
	    'purposeConfig': [sag[0]],
	    'create': [sag[0]],
	    'createPurposeMarketMapping': [sag[0]],
	    'createAdReorderReason': [sag[0]],
	    'createAdReorderDateConfig': [sag[0]],
	    'createautoInitAdConfig': [sag[0]],
	    'createGracePeriodMaster': [sag[0]],
	    'createSamplePurposeMaster': [sag[0]],
	    'createBrandAndSeason': [sag[0]],
	    'adSprAttConfig': [sag[0]],
	    'lcSprAttConfig': [sag[0]],
	    'shipmentConfig': [sag[0], sag[1]],
	    'updateShipment': [sag[0]],
	    'updateCourierShipmentStatus': [sag[0]],
	    'viewClearCourier': [sag[0], sag[1]],
	    'clearADCourier': [sag[0]],
	    'updateException': [sag[0]]
	  }
	};
	
	var shouldShowPageOnMenu = function shouldShowPageOnMenu(accessModel) {
	  var accessModule = accessModel.accessModule,
	      accessFunction = accessModel.accessFunction,
	      accessPage = accessModel.accessPage,
	      accessRole = accessModel.accessRole;
	
	  return !pagesDoNotShowOnMenu[accessModule] || !pagesDoNotShowOnMenu[accessModule][accessFunction] || !pagesDoNotShowOnMenu[accessModule][accessFunction][accessPage] || pagesDoNotShowOnMenu[accessModule][accessFunction][accessPage].indexOf(accessRole) === -1;
	};
	
	var checkUserRight = function checkUserRight(user, fn, page) {
	  for (var i = 0; i < user.accessGroupList.length; i++) {
	    if (accessGroupLimited && accessGroupLimited[page] && accessGroupLimited[page][fn] && accessGroupLimited[page][fn].includes(user.accessGroupList[i].accessGroup)) {
	      return true;
	    }
	  }
	  return false;
	};
	var generateMenu = function generateMenu(user) {
	  if (!user) {
	    return [];
	  }
	
	  var path = function path(str) {
	    return '/' + str.toLowerCase().replace('_', '-');
	  };
	
	  var sortByName = function sortByName(a, b) {
	    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
	  };
	
	  var generateURL = function generateURL(accessModel) {
	    var accessModule = accessModel.accessModule,
	        accessFunction = accessModel.accessFunction,
	        accessPage = accessModel.accessPage,
	        accessPageURL = accessModel.accessPageURL;
	
	    return accessPageURL || path(accessModule) + path(accessFunction) + path(accessPage);
	  };
	
	  var accessGroups = user.accessGroupList;
	  var accessModels = accessGroups.reduce(function (list, accessGroup) {
	    list.push.apply(list, (0, _toConsumableArray3.default)(accessGroup.accessModelList));
	    return list;
	  }, []);
	
	  var modules = [].concat((0, _toConsumableArray3.default)(accessModels.filter(function (accessModel) {
	    return shouldShowPageOnMenu(accessModel);
	  }).reduce(function (map, accessModel, accessModelIndex) {
	    var accessModule = accessModel.accessModule,
	        accessFunction = accessModel.accessFunction,
	        accessPage = accessModel.accessPage,
	        accessRole = accessModel.accessRole,
	        accessPermission = accessModel.accessPermission;
	
	
	    if (!accessModule || !accessFunction || !accessPage) {
	      return map;
	    }
	
	    var moduleItem = void 0;
	    var functionItem = void 0;
	
	    if (!map.has(accessModule)) {
	      map.set(accessModule, {
	        id: accessModule,
	        name: accessModel.accessModuleDescription,
	        functionMap: new _map2.default()
	      });
	    }
	    moduleItem = map.get(accessModule);
	    if (!moduleItem.functionMap.has(accessFunction)) {
	      moduleItem.functionMap.set(accessFunction, {
	        id: accessFunction,
	        name: accessModel.accessFunctionDescription,
	        pageMap: new _map2.default()
	      });
	    }
	    functionItem = moduleItem.functionMap.get(accessFunction);
	    functionItem.pageMap.set(accessPage, {
	      id: accessPage,
	      name: accessModel.accessPageDescription,
	      order: accessModelIndex,
	      accessRole: accessRole,
	      accessPermission: accessPermission,
	      url: generateURL(accessModel)
	    });
	    return map;
	  }, new _map2.default()))).map(function (pair) {
	    return pair[1];
	  }).sort(sortByName);
	  modules.forEach(function (module) {
	    module.functionList = [].concat((0, _toConsumableArray3.default)(module.functionMap)).map(function (pair) {
	      return pair[1];
	    }).sort(sortByName);
	    module.functionList.forEach(function (functionItem) {
	      functionItem.pageList = [].concat((0, _toConsumableArray3.default)(functionItem.pageMap)).map(function (pair) {
	        return pair[1];
	      }).sort(function (a, b) {
	        return a.order - b.order;
	      });
	    });
	  });
	
	  return modules;
	};
	
	var banners = function banners(state) {
	  return state.banners;
	};
	
	exports.default = (_banners$ALERTS$USER$ = {
	  banners: banners
	}, (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.ALERTS, function (state) {
	  return state.alerts;
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.USER, function (state) {
	  return state.user;
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.USER_FULL_NAME, function (state, getters) {
	  return getters[_definition.USER] ? getters[_definition.USER].firstName + ' ' + getters[_definition.USER].lastName : '';
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.ACCESS_GROUPS, function (state, getters) {
	  return getters[_definition.USER].accessGroupList;
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.MENU, function (state, getters) {
	  return generateMenu(getters[_definition.USER]);
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.IS_APP_JS_LOADED, function (state, getters) {
	  return state.isAppJsLoaded;
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.DASHBOARD_STATISTICS, function (state, getters) {
	  return state.dashboardStatistics;
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES, function (state, getters) {
	  return state.clientUserInactiveTimeoutInMinutes;
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.IS_APP_LOADING, function (state, getters) {
	  return state.isAppLoading;
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.SET_CRAR_DATA, function (state, getters) {
	  return function (fn) {
	    getters[_definition.CRAR_DATA] = fn;
	  };
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.SET_PAGE, function (state, getters) {
	  return function (fn) {
	    getters[_definition.PAGE] = fn;
	  };
	}), (0, _defineProperty3.default)(_banners$ALERTS$USER$, _definition.IS_ALLOWED, function (state, getters) {
	  return function (fn) {
	    return checkUserRight(getters[_definition.USER], fn, getters[_definition.PAGE]);
	  };
	}), _banners$ALERTS$USER$);

/***/ }),

/***/ 2379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(20);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _addBanner$removeBann;
	
	var _definition = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addBanner = function addBanner(state, banner) {
	  state.banners.push(banner);
	};
	
	var removeBanner = function removeBanner(state, banner) {
	  var idx = state.banners.indexOf(banner);
	  if (idx !== -1) {
	    state.banners.splice(idx, 1);
	  }
	};
	
	exports.default = (_addBanner$removeBann = {
	  addBanner: addBanner,
	  removeBanner: removeBanner
	}, (0, _defineProperty3.default)(_addBanner$removeBann, _definition.SET_USER, function (state, user) {
	  state.user = user;
	}), (0, _defineProperty3.default)(_addBanner$removeBann, _definition.ADD_ALERT, function (state, alert) {
	  state.alerts.push(alert);
	}), (0, _defineProperty3.default)(_addBanner$removeBann, _definition.REMOVE_ALERT, function (state, alert) {
	  var index = state.alerts.indexOf(alert);
	  if (index !== -1) {
	    state.alerts.splice(index, 1);
	  }
	}), (0, _defineProperty3.default)(_addBanner$removeBann, _definition.SET_APP_JS_LOADED, function (state, loaded) {
	  state.isAppJsLoaded = loaded;
	}), (0, _defineProperty3.default)(_addBanner$removeBann, _definition.CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES, function (state, value) {
	  state.clientUserInactiveTimeoutInMinutes = value;
	}), (0, _defineProperty3.default)(_addBanner$removeBann, _definition.IS_APP_LOADING, function (state, loading) {
	  state.isAppLoading = loading;
	}), _addBanner$removeBann);

/***/ }),

/***/ 3172:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4281:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.65ad64aa36ef9a02bbfe.js